
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as QHNlbnRyeS9icm93c2Vy from '@sentry/browser';
import * as ZmZsYXRl from 'fflate';
import * as ZmlyZWJhc2UvYW5hbHl0aWNz from 'firebase/analytics';
import * as ZmlyZWJhc2UvYXBw from 'firebase/app';
import * as ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw from 'firebase/remote-config';
import * as d2FzbTpqcy1zdHJpbmc from './webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_QHNlbnRyeS9icm93c2Vy_ = QHNlbnRyeS9icm93c2Vy;
const _ref_ZmZsYXRl_ = ZmZsYXRl;
const _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_ = ZmlyZWJhc2UvYW5hbHl0aWNz;
const _ref_ZmlyZWJhc2UvYXBw_ = ZmlyZWJhc2UvYXBw;
const _ref_ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw_ = ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.externrefToLong' : (ref) => BigInt(ref),
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.Promise_$external_fun' : (p0) => new Promise(p0),
    'kotlin.js.__callJsClosure_((Js?)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_2' : (f, trampoline) => getCachedJsObject(f, (p0, p1) => trampoline(f, p0, p1)),
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.resolve_$external_fun' : (_this, p0) => _this.resolve(p0),
    'kotlin.js.Companion_$external_object_getInstance' : () => Promise,
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.promiseSetDeferred' : (promise, deferred) => promise.deferred = deferred,
    'kotlinx.coroutines.promiseGetDeferred' : (promise) => {
        console.assert(promise instanceof Promise, "promiseGetDeferred must receive a promise, but got ", promise);
        return promise.deferred == null ? null : promise.deferred;
    },
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForUint8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0) => new Uint8Array(p0),
    'org.khronos.webgl.Uint8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.Uint8Array_$external_class_instanceof' : (x) => x instanceof Uint8Array,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_2' : (_this) => _this.buffer,
    'org.khronos.webgl.set_$external_fun' : (_this, p0, p1, isDefault0) => _this.set(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.backgroundColor_$external_prop_setter' : (_this, v) => _this.backgroundColor = v,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.zIndex_$external_prop_setter' : (_this, v) => _this.zIndex = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.currentTarget_$external_prop_getter' : (_this) => _this.currentTarget,
    'org.w3c.dom.events.eventPhase_$external_prop_getter' : (_this) => _this.eventPhase,
    'org.w3c.dom.events.bubbles_$external_prop_getter' : (_this) => _this.bubbles,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.defaultPrevented_$external_prop_getter' : (_this) => _this.defaultPrevented,
    'org.w3c.dom.events.composed_$external_prop_getter' : (_this) => _this.composed,
    'org.w3c.dom.events.isTrusted_$external_prop_getter' : (_this) => _this.isTrusted,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.stopPropagation_$external_fun' : (_this, ) => _this.stopPropagation(),
    'org.w3c.dom.events.stopImmediatePropagation_$external_fun' : (_this, ) => _this.stopImmediatePropagation(),
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_3' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1, p2) => _this.removeEventListener(p0, p1, p2),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_2' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.screenX_$external_prop_getter' : (_this) => _this.screenX,
    'org.w3c.dom.events.screenY_$external_prop_getter' : (_this) => _this.screenY,
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.relatedTarget_$external_prop_getter' : (_this) => _this.relatedTarget,
    'org.w3c.dom.events.region_$external_prop_getter' : (_this) => _this.region,
    'org.w3c.dom.events.pageX_$external_prop_getter' : (_this) => _this.pageX,
    'org.w3c.dom.events.pageY_$external_prop_getter' : (_this) => _this.pageY,
    'org.w3c.dom.events.x_$external_prop_getter' : (_this) => _this.x,
    'org.w3c.dom.events.y_$external_prop_getter' : (_this) => _this.y,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.getMethodImplForNodeList' : (obj, index) => obj[index],
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.getMethodImplForStorage' : (obj, key) => obj[key],
    'org.w3c.dom.setMethodImplForStorage' : (obj, key, value) => { obj[key] = value; },
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.screen_$external_prop_getter' : (_this) => _this.screen,
    'org.w3c.dom.innerHeight_$external_prop_getter' : (_this) => _this.innerHeight,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.cancelAnimationFrame_$external_fun' : (_this, p0) => _this.cancelAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.terminate_$external_fun' : (_this, ) => _this.terminate(),
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.src_$external_prop_setter' : (_this, v) => _this.src = v,
    'org.w3c.dom.async_$external_prop_setter' : (_this, v) => _this.async = v,
    'org.w3c.dom.defer_$external_prop_setter' : (_this, v) => _this.defer = v,
    'org.w3c.dom.HTMLScriptElement_$external_class_instanceof' : (x) => x instanceof HTMLScriptElement,
    'org.w3c.dom.HTMLScriptElement_$external_class_get' : () => HTMLScriptElement,
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.innerHTML_$external_prop_setter' : (_this, v) => _this.innerHTML = v,
    'org.w3c.dom.getAttributeNames_$external_fun' : (_this, ) => _this.getAttributeNames(),
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.setAttributeNS_$external_fun' : (_this, p0, p1, p2) => _this.setAttributeNS(p0, p1, p2),
    'org.w3c.dom.removeAttribute_$external_fun' : (_this, p0) => _this.removeAttribute(p0),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.Element_$external_class_get' : () => Element,
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.cookie_$external_prop_getter' : (_this) => _this.cookie,
    'org.w3c.dom.cookie_$external_prop_setter' : (_this, v) => _this.cookie = v,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.createElementNS_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.createElementNS(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.createTextNode_$external_fun' : (_this, p0) => _this.createTextNode(p0),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.parentElement_$external_prop_getter' : (_this) => _this.parentElement,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.cloneNode_$external_fun' : (_this, p0, isDefault0) => _this.cloneNode(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.download_$external_prop_setter' : (_this, v) => _this.download = v,
    'org.w3c.dom.HTMLAnchorElement_$external_class_instanceof' : (x) => x instanceof HTMLAnchorElement,
    'org.w3c.dom.HTMLAnchorElement_$external_class_get' : () => HTMLAnchorElement,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.offsetWidth_$external_prop_getter' : (_this) => _this.offsetWidth,
    'org.w3c.dom.offsetHeight_$external_prop_getter' : (_this) => _this.offsetHeight,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.width_$external_prop_getter_1' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter_1' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.videoWidth_$external_prop_getter' : (_this) => _this.videoWidth,
    'org.w3c.dom.videoHeight_$external_prop_getter' : (_this) => _this.videoHeight,
    'org.w3c.dom.HTMLVideoElement_$external_class_instanceof' : (x) => x instanceof HTMLVideoElement,
    'org.w3c.dom.HTMLVideoElement_$external_class_get' : () => HTMLVideoElement,
    'org.w3c.dom.src_$external_prop_setter_1' : (_this, v) => _this.src = v,
    'org.w3c.dom.preload_$external_prop_setter' : (_this, v) => _this.preload = v,
    'org.w3c.dom.readyState_$external_prop_getter_1' : (_this) => _this.readyState,
    'org.w3c.dom.seeking_$external_prop_getter' : (_this) => _this.seeking,
    'org.w3c.dom.currentTime_$external_prop_getter' : (_this) => _this.currentTime,
    'org.w3c.dom.currentTime_$external_prop_setter' : (_this, v) => _this.currentTime = v,
    'org.w3c.dom.duration_$external_prop_getter' : (_this) => _this.duration,
    'org.w3c.dom.paused_$external_prop_getter' : (_this) => _this.paused,
    'org.w3c.dom.autoplay_$external_prop_setter' : (_this, v) => _this.autoplay = v,
    'org.w3c.dom.loop_$external_prop_setter' : (_this, v) => _this.loop = v,
    'org.w3c.dom.volume_$external_prop_getter' : (_this) => _this.volume,
    'org.w3c.dom.volume_$external_prop_setter' : (_this, v) => _this.volume = v,
    'org.w3c.dom.muted_$external_prop_setter' : (_this, v) => _this.muted = v,
    'org.w3c.dom.load_$external_fun' : (_this, ) => _this.load(),
    'org.w3c.dom.pause_$external_fun' : (_this, ) => _this.pause(),
    'org.w3c.dom.HAVE_METADATA_$external_prop_getter' : (_this) => _this.HAVE_METADATA,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => HTMLMediaElement,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.hostname_$external_prop_getter' : (_this) => _this.hostname,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.reload_$external_fun' : (_this, ) => _this.reload(),
    'org.w3c.dom.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.StorageEvent_$external_class_instanceof' : (x) => x instanceof StorageEvent,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.key_$external_fun' : (_this, p0) => _this.key(p0),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.Storage_$external_class_instanceof' : (x) => x instanceof Storage,
    'org.w3c.dom.Storage_$external_class_get' : () => Storage,
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.accept_$external_prop_setter' : (_this, v) => _this.accept = v,
    'org.w3c.dom.checked_$external_prop_setter' : (_this, v) => _this.checked = v,
    'org.w3c.dom.files_$external_prop_getter' : (_this) => _this.files,
    'org.w3c.dom.multiple_$external_prop_setter' : (_this, v) => _this.multiple = v,
    'org.w3c.dom.name_$external_prop_getter' : (_this) => _this.name,
    'org.w3c.dom.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'org.w3c.dom.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.value_$external_prop_getter' : (_this) => _this.value,
    'org.w3c.dom.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.value_$external_prop_getter_1' : (_this) => _this.value,
    'org.w3c.dom.value_$external_prop_setter_1' : (_this, v) => _this.value = v,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.remove_$external_fun' : (_this, p0) => _this.remove(...p0),
    'org.w3c.dom.toggle_$external_fun' : (_this, p0, p1, isDefault0) => _this.toggle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.Text_$external_class_instanceof' : (x) => x instanceof Text,
    'org.w3c.dom.Text_$external_class_get' : () => Text,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.files_$external_prop_getter_1' : (_this) => _this.files,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.readyState_$external_prop_getter_2' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => WebSocket,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.platform_$external_prop_getter' : (_this) => _this.platform,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.onLine_$external_prop_getter' : (_this) => _this.onLine,
    'org.w3c.dom.oncancel_$external_prop_setter' : (_this, v) => _this.oncancel = v,
    'org.w3c.dom.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
    'org.w3c.dom.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.setTimeout_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.setTimeout(p0, isDefault0 ? undefined : p1, ...p2, ),
    'org.w3c.dom.clearTimeout_$external_fun' : (_this, p0, isDefault0) => _this.clearTimeout(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.localStorage_$external_prop_getter' : (_this) => _this.localStorage,
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.remove_$external_fun_1' : (_this, ) => _this.remove(),
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.Companion_$external_object_getInstance_3' : () => ({}),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'org.w3c.dom.data_$external_prop_setter' : (_this, v) => _this.data = v,
    'org.w3c.dom.Companion_$external_object_getInstance_4' : () => ({}),
    'org.w3c.dom.returnValue_$external_prop_setter' : (_this, v) => _this.returnValue = v,
    'org.w3c.dom.BeforeUnloadEvent_$external_class_instanceof' : (x) => x instanceof BeforeUnloadEvent,
    'org.w3c.dom.BeforeUnloadEvent_$external_class_get' : () => BeforeUnloadEvent,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.svg.SVGElement_$external_class_instanceof' : (x) => x instanceof SVGElement,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.BlobPropertyBag_js_code' : (type) => ({ type: type }),
    'org.w3c.files.FilePropertyBag_js_code' : (lastModified, type) => ({ lastModified: lastModified, type: type }),
    'org.w3c.files.getMethodImplForFileList' : (obj, index) => obj[index],
    'org.w3c.files.File_$external_fun' : (p0, p1, p2, isDefault0) => new File(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
    'org.w3c.files.File_$external_class_instanceof' : (x) => x instanceof File,
    'org.w3c.files.File_$external_class_get' : () => File,
    'org.w3c.files.Blob_$external_fun' : (p0, p1, isDefault0, isDefault1) => new Blob(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.files.size_$external_prop_getter' : (_this) => _this.size,
    'org.w3c.files.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.w3c.dom.item_$external_fun_2' : (_this, p0) => _this.item(p0),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl.crateCallbackObj' : () => { return {} },
    'org.jetbrains.skia.impl.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'org.jetbrains.skia.impl._registerCallback_$external_fun' : (p0, p1, p2) => _ref_Li9za2lrby5tanM_c2tpa29BcGk._registerCallback(p0, p1, p2),
    'org.jetbrains.skia.impl._createLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._createLocalCallbackScope(),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skia.webext.skikoArrayBuffer' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'org.jetbrains.skia.webext.copyBuffer' : (src, dst, dstOffset) => { 
            var dstView = new Uint8Array(dst);
            var srcView = new Uint8Array(src);
            dstView.set(srcView, dstOffset);
         },
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.toggleVisibility' : (element, isHidden) => { 
           element.style.visibility = isHidden ? "hidden" : "visible";
         },
    'androidx.compose.ui.viewinterop.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.setClipPath' : (element, top, right, bottom, left) => { 
           element.style.setProperty("clip-path", "inset(" + top + "px " + right + "px " + bottom + "px " + left + "px)"); 
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'coil3.decode.WebWorkerRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'coil3.decode.id_$external_prop_getter' : (_this) => _this.id,
    'coil3.decode.kind_$external_prop_getter' : (_this) => _this.kind,
    'coil3.decode.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'coil3.decode.message_$external_prop_getter' : (_this) => _this.message,
    'coil3.fetch.fetch' : (url) => fetch(url),
    'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'core.buildconfig.nameBuildInSessionLog' : (build) => globalThis.andalusiBuild = build,
    'core.buildconfig.storedLogLevel' : () => (() => { try { return localStorage.getItem('andalusi_log_level'); } catch (e) { return null; } })(),
    'com.andalusi.app.android.common.performanceMark' : (name) => performance.mark(name),
    'com.andalusi.app.android.common.performanceMeasure' : (name, startMark) => performance.measure(name, startMark),
    'com.andalusi.app.android.common.performanceClearMarks' : (name) => performance.clearMarks(name),
    'com.andalusi.app.android.common.hasVideoEncoder' : () => typeof VideoEncoder === 'function' && typeof VideoFrame === 'function',
    'com.andalusi.app.android.common.isEncoderConfigSupported' : (codec, width, height, fps, bitrate) => VideoEncoder.isConfigSupported({
                codec: Array.from(codec).join(''), width: width, height: height, framerate: fps, bitrate: bitrate,
                ...(codec.startsWith('avc1') ? { avc: { format: 'avc' } } : {}),
            }).then((support) => support.supported === true),
    'com.andalusi.app.android.common.isAudioEncoderConfigSupported' : (codec, bitrate) => typeof AudioEncoder !== 'function' ? Promise.resolve(false) : AudioEncoder.isConfigSupported({
                codec: codec, sampleRate: 48000, numberOfChannels: 2, bitrate: bitrate,
                ...(codec.startsWith('mp4a') ? { aac: { format: 'aac' } } : { opus: { format: 'opus' } }),
            }).then((support) => support.supported === true),
    'com.andalusi.app.android.common.sliceFromWasmMemory' : (memory, address, size) => new Int8Array(memory.slice(address, address + size)),
    'com.andalusi.app.android.common.memoryBuffer' : (memory) => memory.buffer,
    'com.andalusi.app.android.common.sentry.jsError' : (name, message, stack) => Object.assign(new Error(message), { name: name, stack: stack }),
    'com.andalusi.app.android.common.sentry.logBreadcrumb' : (message) => ({ message: message, category: 'log', level: 'info' }),
    'com.andalusi.app.android.common.sentry.sentryOptions' : (dsn, environment, release, beforeSend) => ({
                dsn: dsn, environment: environment, release: release, beforeSend: beforeSend,
                ignoreErrors: ['The user aborted a request'],
            }),
    'com.andalusi.app.android.common.sentry.wasmNamesBeforeSend' : () => (() => {
            const tables = new Map();
            const wasmFrame = /^(.*\.wasm):wasm-function\[(\d+)\]:0x[0-9a-f]+$/i;
            const tableFor = (moduleUrl) => {
                const url = moduleUrl.replace(/\.wasm$/, '.names.json');
                if (!tables.has(url)) {
                    tables.set(url, fetch(url).then((r) => (r.ok ? r.json() : null)).catch(() => null));
                }
                return tables.get(url);
            };
            return async (event) => {
                const values = (event.exception && event.exception.values) || [];
                for (const value of values) {
                    const frames = (value.stacktrace && value.stacktrace.frames) || [];
                    for (const frame of frames) {
                        const match = frame.filename && wasmFrame.exec(frame.filename);
                        if (!match) continue;
                        const table = await tableFor(match[1]);
                        const name = table && table[match[2]];
                        if (!name) continue;
                        frame.function = name;
                        frame.filename = match[1];
                        frame.in_app = true;
                    }
                }
                return event;
            };
        })(),
    'com.andalusi.app.android.common.sentry.sentryUser' : (id) => ({ id: id }),
    'com.andalusi.app.android.common.sentry.randomUuid' : () => crypto.randomUUID(),
    'com.andalusi.app.android.common.sentry.externals.captureException_$external_fun' : (p0) => _ref_QHNlbnRyeS9icm93c2Vy_.captureException(p0),
    'com.andalusi.app.android.common.sentry.externals.addBreadcrumb_$external_fun' : (p0) => _ref_QHNlbnRyeS9icm93c2Vy_.addBreadcrumb(p0),
    'com.andalusi.app.android.common.sentry.externals.init_$external_fun' : (p0) => _ref_QHNlbnRyeS9icm93c2Vy_.init(p0),
    'com.andalusi.app.android.common.sentry.externals.setUser_$external_fun' : (p0) => _ref_QHNlbnRyeS9icm93c2Vy_.setUser(p0),
    'com.andalusi.indexeddb.value_$external_prop_getter' : (_this) => _this.value,
    'com.andalusi.indexeddb.key_$external_prop_getter' : (_this) => _this.key,
    'com.andalusi.indexeddb.continue_$external_fun' : (_this, ) => _this.continue(),
    'com.andalusi.indexeddb.name_$external_prop_getter' : (_this) => _this.name,
    'com.andalusi.indexeddb.objectStoreNames_$external_prop_getter' : (_this) => _this.objectStoreNames,
    'com.andalusi.indexeddb.close_$external_fun' : (_this, ) => _this.close(),
    'com.andalusi.indexeddb.createObjectStore_$external_fun' : (_this, p0) => _this.createObjectStore(p0),
    'com.andalusi.indexeddb.transaction_$external_fun' : (_this, p0, p1) => _this.transaction(p0, p1),
    'com.andalusi.indexeddb.transaction_$external_fun_1' : (_this, p0, p1, p2) => _this.transaction(p0, p1, p2),
    'com.andalusi.indexeddb.IDBDatabase_$external_class_instanceof' : (x) => x instanceof IDBDatabase,
    'com.andalusi.indexeddb.IDBDatabase_$external_class_get' : () => IDBDatabase,
    'com.andalusi.indexeddb.getIndexedDbFromWindow' : () => window.indexedDB,
    'com.andalusi.indexeddb.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
    'com.andalusi.indexeddb.deleteDatabase_$external_fun' : (_this, p0) => _this.deleteDatabase(p0),
    'com.andalusi.indexeddb.bound_$external_fun' : (_this, p0, p1, p2, p3) => _this.bound(p0, p1, p2, p3),
    'com.andalusi.indexeddb.Companion_$external_object_getInstance' : () => IDBKeyRange,
    'com.andalusi.indexeddb.name_$external_prop_getter_1' : (_this) => _this.name,
    'com.andalusi.indexeddb.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'com.andalusi.indexeddb.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'com.andalusi.indexeddb.get_$external_fun' : (_this, p0) => _this.get(p0),
    'com.andalusi.indexeddb.getAll_$external_fun' : (_this, ) => _this.getAll(),
    'com.andalusi.indexeddb.getAllKeys_$external_fun' : (_this, p0) => _this.getAllKeys(p0),
    'com.andalusi.indexeddb.getAllKeys_$external_fun_1' : (_this, p0, p1) => _this.getAllKeys(p0, p1),
    'com.andalusi.indexeddb.getKey_$external_fun' : (_this, p0) => _this.getKey(p0),
    'com.andalusi.indexeddb.openCursor_$external_fun' : (_this, p0, p1) => _this.openCursor(p0, p1),
    'com.andalusi.indexeddb.openKeyCursor_$external_fun' : (_this, p0, p1) => _this.openKeyCursor(p0, p1),
    'com.andalusi.indexeddb.error_$external_prop_getter' : (_this) => _this.error,
    'com.andalusi.indexeddb.transaction_$external_prop_getter' : (_this) => _this.transaction,
    'com.andalusi.indexeddb.result_$external_prop_getter' : (_this) => _this.result,
    'com.andalusi.indexeddb.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'com.andalusi.indexeddb.onsuccess_$external_prop_setter' : (_this, v) => _this.onsuccess = v,
    'com.andalusi.indexeddb.IDBRequest_$external_class_instanceof' : (x) => x instanceof IDBRequest,
    'com.andalusi.indexeddb.IDBRequest_$external_class_get' : () => IDBRequest,
    'com.andalusi.indexeddb.onupgradeneeded_$external_prop_setter' : (_this, v) => _this.onupgradeneeded = v,
    'com.andalusi.indexeddb.IDBOpenDBRequest_$external_class_instanceof' : (x) => x instanceof IDBOpenDBRequest,
    'com.andalusi.indexeddb.IDBOpenDBRequest_$external_class_get' : () => IDBOpenDBRequest,
    'com.andalusi.indexeddb.commitJsTypeOf' : (transaction) => typeof(transaction.commit),
    'com.andalusi.indexeddb.error_$external_prop_getter_1' : (_this) => _this.error,
    'com.andalusi.indexeddb.objectStore_$external_fun' : (_this, p0) => _this.objectStore(p0),
    'com.andalusi.indexeddb.abort_$external_fun' : (_this, ) => _this.abort(),
    'com.andalusi.indexeddb.commit_$external_fun' : (_this, ) => _this.commit(),
    'com.andalusi.indexeddb.onabort_$external_prop_setter' : (_this, v) => _this.onabort = v,
    'com.andalusi.indexeddb.onerror_$external_prop_setter_1' : (_this, v) => _this.onerror = v,
    'com.andalusi.indexeddb.oncomplete_$external_prop_setter' : (_this, v) => _this.oncomplete = v,
    'com.andalusi.indexeddb.oldVersion_$external_prop_getter' : (_this) => _this.oldVersion,
    'com.andalusi.indexeddb.newVersion_$external_prop_getter' : (_this) => _this.newVersion,
    'com.andalusi.indexeddb.IDBVersionChangeEvent_$external_class_instanceof' : (x) => x instanceof IDBVersionChangeEvent,
    'com.andalusi.indexeddb.IDBVersionChangeEvent_$external_class_get' : () => IDBVersionChangeEvent,
    'com.andalusi.indexeddb.core.getIndexedDB' : () => self.indexedDB || self.webkitIndexedDB,
    'com.andalusi.indexeddb.core.setJsoDurability' : 
        (jso, jsValue) => {
            jso.durability = jsValue;
        }
    ,
    'com.andalusi.indexeddb.core.jso' : () => ({}),
    'com.andalusi.networking.createJsEmptyObject' : () => ({}),
    'com.andalusi.networking.recordSize' : (rec) => rec?.size,
    'com.andalusi.networking.recordModified' : (rec) => rec?.modified,
    'com.andalusi.networking.recordKind' : (rec) => rec?.kind,
    'com.andalusi.networking.recordText' : (rec) => rec?.text,
    'com.andalusi.networking.getBlob' : (rec) => rec?.blob,
    'com.andalusi.networking.blobType' : (blob) => blob.type,
    'com.andalusi.networking.retypedBlob' : (blob, type) => blob.slice(0, blob.size, type),
    'com.andalusi.networking.getBytes' : (rec) => rec?.bytes,
    'com.andalusi.networking.blobArrayBuffer' : (blob) => blob.arrayBuffer(),
    'com.andalusi.networking.storageEstimate' : () => navigator.storage.estimate(),
    'com.andalusi.networking.estimateQuota' : (estimate) => estimate.quota ?? 0,
    'com.andalusi.networking.estimateUsage' : (estimate) => estimate.usage ?? 0,
    'com.andalusi.networking.blobSize' : (blob) => blob.size,
    'com.andalusi.networking.blobSlice' : (blob, start, end) => blob.slice(start, end),
    'com.andalusi.networking.setTextRecordProps' : 
        (record, kind, text, size, modified) => {
            record.kind = kind;
            record.text = text;
            record.size = size;
            record.modified = modified;
        }
    ,
    'com.andalusi.networking.setBytesRecordProps' : 
        (record, kind, bytes, size, modified) => {
            record.kind = kind;
            record.bytes = bytes;
            record.size = size;
            record.modified = modified;
        }
    ,
    'com.andalusi.networking.setBlobRecordProps' : 
        (record, kind, blob, size, modified) => {
            record.kind = kind;
            record.blob = blob;
            record.size = size;
            record.modified = modified;
        }
    ,
    'com.andalusi.networking.storagePersisted' : () => navigator.storage && navigator.storage.persisted ? navigator.storage.persisted() : Promise.resolve(false),
    'com.andalusi.networking.storagePersist' : () => navigator.storage && navigator.storage.persist ? navigator.storage.persist() : Promise.resolve(false),
    'com.andalusi.networking.readVideoMetadata' : (url) => new Promise((resolve) => {
                const video = document.createElement('video');
                video.preload = 'metadata';
                video.muted = true;
                const done = (value) => { video.removeAttribute('src'); video.load(); resolve(value); };
                video.addEventListener('error', () => done(null), { once: true });
                video.addEventListener('loadedmetadata', () => done(
                    video.videoWidth > 0 && video.videoHeight > 0
                        ? { width: video.videoWidth, height: video.videoHeight, duration: isFinite(video.duration) ? video.duration : 0 }
                        : null
                ), { once: true });
                video.src = url;
            }),
    'com.andalusi.networking.metadataWidth' : (info) => info.width,
    'com.andalusi.networking.metadataHeight' : (info) => info.height,
    'com.andalusi.networking.metadataDuration' : (info) => info.duration,
    'com.andalusi.networking.startDownload' : (url) => (() => {
                const download = { controller: new AbortController(), chunks: [], response: null, reader: null };
                download.status = fetch(url, { signal: download.controller.signal })
                    .then((response) => { download.response = response; return response.status; });
                return download;
            })(),
    'com.andalusi.networking.statusOf' : (download) => download.status,
    'com.andalusi.networking.announcedLength' : (download) => (() => { const length = download.response.headers.get('content-length'); return length === null ? -1 : Number(length); })(),
    'com.andalusi.networking.readChunk' : (download) => (download.reader ??= download.response.body.getReader()).read().then(({ done, value }) => {
                if (done) return -1;
                download.chunks.push(value);
                return value.length;
            }),
    'com.andalusi.networking.downloadedBlob' : (download) => new Blob(download.chunks),
    'com.andalusi.networking.abortDownload' : (download) => download.controller.abort(),
    'com.andalusi.networking.startPut' : (url, blob, onProgress) => (() => {
                const xhr = new XMLHttpRequest();
                const status = new Promise((resolve, reject) => {
                    xhr.upload.onprogress = (event) => onProgress(event.loaded);
                    xhr.onload = () => resolve(xhr.status);
                    xhr.onerror = () => reject(new Error('network error'));
                    xhr.ontimeout = () => reject(new Error('timeout'));
                    xhr.onabort = () => reject(new Error('aborted'));
                });
                xhr.open('PUT', url);
                xhr.send(blob.type ? blob.slice(0, blob.size, '') : blob);
                return { xhr, status };
            })(),
    'com.andalusi.networking.statusOf_1' : (request) => request.status,
    'com.andalusi.networking.abortPut' : (request) => request.xhr.abort(),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'js.array.unsafeGet_$external_fun' : (_this, p0) => _this.at(p0),
    'js.objects.entries_$external_fun' : (_this, p0) => _this.entries(p0),
    'js.objects.Companion_$external_object_getInstance' : () => Object,
    'web.encoding.TextDecoder_$external_fun' : (p0, p1, isDefault0, isDefault1) => new TextDecoder(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'web.encoding.decode_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.decode(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'androidx.compose.material.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'com.andalusi.core.zip_$external_fun' : (p0, p1) => _ref_ZmZsYXRl_.zip(p0, p1),
    'com.andalusi.core.unzip_$external_fun' : (p0, p1) => _ref_ZmZsYXRl_.unzip(p0, p1),
    'com.andalusi.core.newZipObject' : () => ({}),
    'com.andalusi.core.setStoredEntry' : (obj, key, value) => { obj[key] = [value, { level: 0 }] },
    'com.andalusi.core.setDeflatedEntry' : (obj, key, value) => { obj[key] = value },
    'com.andalusi.core.errorMessage' : (err) => (err && err.message) ? String(err.message) : String(err),
    'com.andalusi.core.newJsObject' : () => ({}),
    'com.andalusi.core.setObjectEntry' : (obj, key, value) => { obj[key] = value },
    'com.andalusi.core.core.arrayBufferOf' : (file) => file.arrayBuffer(),
    'com.andalusi.core.core.canPlayType' : (type) => document.createElement('video').canPlayType(type),
    'com.andalusi.core.extensions.jsFormatGroupedInteger' : (value, languageTag) => new Intl.NumberFormat(languageTag, { maximumFractionDigits: 0 }).format(value),
    'com.andalusi.core.extensions.jsFormatMediumDateShortTime' : (epochMillis, languageTag) => new Intl.DateTimeFormat(languageTag, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(epochMillis)),
    'com.andalusi.core.firebase.analytics.externals.getAnalytics_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.getAnalytics(p0),
    'com.andalusi.core.firebase.analytics.externals.logEvent_$external_fun' : (p0, p1, p2, p3) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.logEvent(p0, p1, p2, p3),
    'com.andalusi.core.firebase.analytics.externals.setUserProperties_$external_fun' : (p0, p1, p2) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.setUserProperties(p0, p1, p2),
    'com.andalusi.core.firebase.app.externals.initializeApp_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXBw_.initializeApp(p0, p1),
    'com.andalusi.core.firebase.remoteconfig.externals.getRemoteConfig_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw_.getRemoteConfig(p0),
    'com.andalusi.core.firebase.remoteconfig.externals.fetchAndActivate_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw_.fetchAndActivate(p0),
    'com.andalusi.core.firebase.remoteconfig.externals.getString_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvcmVtb3RlLWNvbmZpZw_.getString(p0, p1),
    'com.andalusi.core.gpu.copyCanvasPixels' : (wasm, source, width, height, addr) => {
            let context = source.getContext('2d');
            if (source.width !== width || source.height !== height) {
                context = new OffscreenCanvas(width, height).getContext('2d');
                context.drawImage(source, 0, 0, width, height);
            }
            const data = context.getImageData(0, 0, width, height).data;
            new Uint8Array(wasm._.memory.buffer, addr, data.byteLength).set(data);
        },
    'com.andalusi.core.gpu.isContextLost' : (gl) => gl.isContextLost(),
    'com.andalusi.core.gpu.maxRenderSide' : (gl) => (() => {
            try {
                if (!gl || gl.isContextLost()) return 0;
                const side = Math.min(gl.getParameter(gl.MAX_TEXTURE_SIZE), gl.getParameter(gl.MAX_RENDERBUFFER_SIZE));
                return Number.isFinite(side) ? side : 0;
            } catch (e) {
                return 0;
            }
        })(),
    'com.andalusi.core.gpu.watchContextLoss' : (gl, onLost) => { {
            const canvas = gl.canvas;
            if (canvas && !canvas.andalusiLossWatched) {
                canvas.andalusiLossWatched = true;
                canvas.addEventListener('webglcontextlost', () => onLost());
            }
        } },
    'com.andalusi.core.gpu.webGl2Attributes' : () => ({ majorVersion: 2, alpha: 1, depth: 1, stencil: 8, antialias: 0, premultipliedAlpha: 1, preserveDrawingBuffer: 0, enableExtensionsByDefault: 1 }),
    'com.andalusi.core.gpu.copyIntoSkiaHeap' : (wasm, source, addr) => new Uint8Array(wasm._.memory.buffer, addr, source.byteLength).set(new Uint8Array(source)),
    'com.andalusi.core.gpu.sliceSkiaHeap' : (wasm, addr, size) => new Uint8ClampedArray(wasm._.memory.buffer.slice(addr, addr + size)),
    'com.andalusi.core.gpu.handle_$external_prop_getter' : (_this) => _this.handle,
    'com.andalusi.core.gpu.GLctx_$external_prop_getter' : (_this) => _this.GLctx,
    'com.andalusi.core.gpu.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'com.andalusi.core.gpu.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'com.andalusi.core.gpu.currentContext_$external_prop_getter' : (_this) => _this.currentContext,
    'com.andalusi.core.gpu.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'com.andalusi.core.gpu.loadedWasm_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.loadedWasm,
    'com.andalusi.core.gpu.createVideoTexture' : (GL, width, height) => (() => {
            const gl = GL.currentContext.GLctx;
            const previous = gl.getParameter(gl.TEXTURE_BINDING_2D);
            const texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA8, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            gl.bindTexture(gl.TEXTURE_2D, previous);
            const id = GL.getNewId(GL.textures);
            texture.name = id;
            GL.textures[id] = texture;
            return id;
        })(),
    'com.andalusi.core.gpu.uploadVideoFrame' : (GL, id, source, width, height) => { {
            const gl = GL.currentContext.GLctx;
            const previous = gl.getParameter(gl.TEXTURE_BINDING_2D);
            gl.bindTexture(gl.TEXTURE_2D, GL.textures[id]);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA8, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, source);
            gl.bindTexture(gl.TEXTURE_2D, previous);
        } },
    'com.andalusi.core.gpu.watchVideoFrames' : (element, onFrame) => (() => {
            const watch = { element, id: 0, stopped: false };
            const tick = () => {
                if (watch.stopped) return;
                onFrame();
                watch.id = element.requestVideoFrameCallback(tick);
            };
            watch.onEvent = () => { if (!watch.stopped) onFrame(); };
            element.addEventListener('seeked', watch.onEvent);
            element.addEventListener('loadeddata', watch.onEvent);
            watch.id = element.requestVideoFrameCallback(tick);
            return watch;
        })(),
    'com.andalusi.core.gpu.stopWatchingVideoFrames' : (watch) => { {
            watch.stopped = true;
            watch.element.cancelVideoFrameCallback(watch.id);
            watch.element.removeEventListener('seeked', watch.onEvent);
            watch.element.removeEventListener('loadeddata', watch.onEvent);
        } },
    'com.andalusi.core.videoPlayer.mediaErrorOf' : (element) => element.error ? ('code ' + element.error.code + ' ' + (element.error.message || '')) : 'no error',
    'com.andalusi.core.videoPlayer.playElement' : (element, onRefused) => { element.play().catch((e) => onRefused(e && e.name ? String(e.name) : 'Error')); },
    'com.andalusi.core.videoPlayer.afterNextUserGesture' : (action) => {
        const types = ['pointerdown', 'pointerup', 'keydown'];
        const once = () => {
            types.forEach((type) => document.removeEventListener(type, once, true));
            action();
        };
        types.forEach((type) => document.addEventListener(type, once, true));
    },
    'com.andalusi.core.worker.getSkikoMemory' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'com.andalusi.core.worker.WebWorkerRequest' : (id, arr, width, height) => ({ id: id, data: arr, w: width, h: height }),
    'com.andalusi.core.worker.EncoderWorkerRequest' : (id, pixels, width, height, mime, quality) => ({ id: id, pixels: pixels, w: width, h: height, mime: mime, quality: quality }),
    'com.andalusi.core.worker.describeWorkerError' : (event) => [event.message, event.filename, event.lineno].filter(Boolean).join(' ') || event.type,
    'com.andalusi.core.worker.postTransferring' : (worker, message, buffer) => worker.postMessage(message, [buffer]),
    'com.andalusi.core.worker.newModuleWorker' : (url) => new Worker(url, { type: 'module' }),
    'com.andalusi.core.worker.resolveAgainstBaseUri' : (relativeUrl) => new URL(relativeUrl, document.baseURI).href,
    'com.andalusi.core.worker.workerBlob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'com.andalusi.core.worker.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'com.andalusi.core.worker.id_$external_prop_getter' : (_this) => _this.id,
    'com.andalusi.core.worker.kind_$external_prop_getter' : (_this) => _this.kind,
    'com.andalusi.core.worker.message_$external_prop_getter' : (_this) => _this.message,
    'feature.projects.sync.callRelease' : (release) => release(),
    'feature.projects.sync.heldLockNames' : () => (
            !navigator.locks ? Promise.resolve('') :
            navigator.locks.query().then((state) => state.held.map((lock) => lock.name).join('\n'))
        ),
    'feature.projects.sync.requestLock' : (name, ifAvailable) => (
            !navigator.locks ? Promise.resolve(() => {}) :
            new Promise((resolve) => {
                navigator.locks.request(name, { ifAvailable: ifAvailable }, (lock) => {
                    if (!lock) { resolve(null); return undefined; }
                    return new Promise((release) => resolve(release));
                });
            })
        ),
    'feature.projects.sync.releaseOnceGranted' : (granted) => { granted.then((release) => release && release()); },
    'com.andalusi.app.database.folders.setFolderRecordProps' : 
        (record, json) => {
            record.json = json;
        }
    ,
    'com.andalusi.app.database.folders.folderJson' : (folder) => folder?.json,
    'com.andalusi.app.database.projects.setProjectRecordProps' : 
        (record, json) => {
            record.json = json;
        }
    ,
    'com.andalusi.app.database.projects.projectJson' : (project) => project?.json,
    'io.github.alexzhirkevich.compottie.internal.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'io.github.alexzhirkevich.compottie.internal.id_$external_prop_getter' : (_this) => _this.id,
    'io.github.alexzhirkevich.compottie.internal.kind_$external_prop_getter' : (_this) => _this.kind,
    'io.github.alexzhirkevich.compottie.internal.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'io.github.alexzhirkevich.compottie.internal.id_$external_prop_getter_1' : (_this) => _this.id,
    'io.github.alexzhirkevich.compottie.internal.message_$external_prop_getter' : (_this) => _this.message,
    'io.github.alexzhirkevich.compottie.internal.platform.DecodeImageRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'io.github.alexzhirkevich.compottie.internal.platform.getSkikoMemory' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'io.github.alexzhirkevich.compottie.currentTimeDouble' : () => Date.now(),
    'io.github.alexzhirkevich.compottie.DecompressionRequest' : (id, bytes) => ({ id: id, bytes: bytes }),
    'com.andalusi.preset.components.clipboardWriteText' : (text) => navigator.clipboard.writeText(text),
    'com.andalusi.preset.components.encodeURIComponent_$external_fun' : (p0) => encodeURIComponent(p0),
    'core.video.drawVideoFrame' : (url, seconds, width, height, onStillClear) => new Promise((resolve) => {
                const video = document.createElement('video');
                video.preload = 'auto';
                video.muted = true;
                let settled = false;
                const done = (value) => {
                    if (settled) return;
                    settled = true;
                    clearTimeout(timer);
                    video.removeAttribute('src');
                    video.load();
                    resolve(value);
                };
                const timer = setTimeout(() => done(null), 10000);
                const read = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const context = canvas.getContext('2d');
                    context.drawImage(video, 0, 0, width, height);
                    return context.getImageData(0, 0, width, height).data;
                };
                const isClear = (data) => {
                    for (let i = 3; i < data.length; i += 4 * 61) if (data[i] !== 0) return false;
                    return true;
                };
                const draw = () => {
                    try {
                        const data = read();
                        // Safari fires 'seeked' before the frame can be drawn: the canvas stays clear
                        // until the element presents the frame.
                        if (!isClear(data) || !video.requestVideoFrameCallback) return done(data.buffer);
                        let redrawn = false;
                        const redraw = () => {
                            if (redrawn || settled) return;
                            redrawn = true;
                            try {
                                const again = read();
                                if (isClear(again)) onStillClear();
                                done(again.buffer);
                            } catch (error) {
                                done(null);
                            }
                        };
                        video.requestVideoFrameCallback(redraw);
                        setTimeout(redraw, 500);
                    } catch (error) {
                        done(null);
                    }
                };
                video.addEventListener('error', () => done(null), { once: true });
                video.addEventListener('loadedmetadata', () => {
                    const end = isFinite(video.duration) ? Math.max(video.duration - 0.05, 0) : 0;
                    const at = Math.min(Math.max(seconds, 0), end);
                    if (at > 0) {
                        video.addEventListener('seeked', draw, { once: true });
                        video.currentTime = at;
                    } else if (video.readyState >= 2) {
                        draw();
                    } else {
                        video.addEventListener('loadeddata', draw, { once: true });
                    }
                }, { once: true });
                video.src = url;
            }),
    'core.video.skikoMemory' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'com.andalusi.potrace.potraceRequest' : (id, rgba, w, h) => ({ id: id, rgba: rgba, w: w, h: h }),
    'com.andalusi.potrace.svg_$external_prop_getter' : (_this) => _this.svg,
    'com.mohamedrejeb.harfbuzz.core.jsTypedArrayLength' : (arr) => arr.length,
    'com.mohamedrejeb.harfbuzz.core.jsArrayLength' : (arr) => arr.length,
    'com.mohamedrejeb.harfbuzz.core.jsArrayGet' : (arr, i) => arr[i],
    'com.mohamedrejeb.harfbuzz.core.jsInt32ArrayGet' : (arr, i) => arr[i],
    'com.mohamedrejeb.harfbuzz.core.jsArrayGetF32' : (arr, i) => arr[i],
    'com.mohamedrejeb.harfbuzz.core.jsCopyUint8ArrayToWasmMemory' : 
        (arr, dstAddr) => {
            const n = arr.length;
            if (n > 0) {
                new Uint8Array(wasmExports.memory.buffer, dstAddr, n).set(arr);
            }
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsCopyInt32ArrayToWasmMemory' : 
        (arr, dstAddr) => {
            const n = arr.length;
            if (n > 0) {
                new Int32Array(wasmExports.memory.buffer, dstAddr, n).set(arr);
            }
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsCopyFloat32ArrayToWasmMemory' : 
        (arr, dstAddr) => {
            const n = arr.length;
            if (n > 0) {
                new Float32Array(wasmExports.memory.buffer, dstAddr, n).set(arr);
            }
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.base64ToInt32Array' : 
        (b64) => {
            const bin = atob(b64);
            const buf = new ArrayBuffer(bin.length);
            const bytes = new Uint8Array(buf);
            for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
            return new Int32Array(buf);
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.base64ToFloat32Array' : 
        (b64) => {
            const bin = atob(b64);
            const buf = new ArrayBuffer(bin.length);
            const bytes = new Uint8Array(buf);
            for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
            return new Float32Array(buf);
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsCopyWasmMemoryToFreshUint8Array' : 
        (srcAddr, len) => {
            const buf = new ArrayBuffer(len);
            if (len > 0) {
                new Uint8Array(buf).set(
                    new Uint8Array(wasmExports.memory.buffer, srcAddr, len)
                );
            }
            return new Uint8Array(buf);
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsObjectKeysAsInts' : 
        (o) => {
            if (o == null) return new Int32Array(0);
            const ks = Object.keys(o);
            const out = new Int32Array(ks.length);
            for (let i = 0; i < ks.length; i++) out[i] = ks[i] | 0;
            return out;
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsScheduleMacrotask' : (resume) => { setTimeout(resume, 0); },
    'com.mohamedrejeb.harfbuzz.core.jsPerfMark' : (name) => { try { performance.mark(name); } catch (e) {} },
    'com.mohamedrejeb.harfbuzz.core.jsPerfMeasure' : (name, startMark) => { try { performance.measure(name, startMark); } catch (e) {} },
    'com.mohamedrejeb.harfbuzz.core.postRequest' : 
        (worker, id, type, payload, transfer) => {
            const msg = { id, type, payload };
            worker.postMessage(msg, transfer ? [transfer] : []);
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.createWorker' : 
        (handleReply, handleWorkerError) => {
            // Resolve the worker script against the document base URL (which honours
            // <base href>) rather than self.location.href. Under a deep SPA route
            // like /template/8979, self.location.href resolves './hb-worker.js' to
            // '/template/hb-worker.js' (404) even though the asset is served from
            // the site root; document.baseURI respects the page's <base href="/">
            // and resolves to '/hb-worker.js'. Falls back to self.location.href
            // when no document is present (e.g. a nested worker realm).
            const base = (typeof document !== 'undefined' && document.baseURI)
                ? document.baseURI
                : self.location.href;
            const w = new Worker(new URL('./hb-worker.js', base));
            w.onmessage = (e) => {
                const { id, type, payload } = e.data;
                const isError = type === 'error';
                const message = isError ? (payload && payload.message) : null;
                handleReply(id, isError, payload, message);
            };
            // A worker load/runtime failure (script 404, syntax error, missing
            // dependency, structured-clone failure) fires here with no reply for
            // any in-flight RPC. Surface to console for diagnosis AND notify the
            // Kotlin side so it can fail every pending await instead of leaving
            // them parked forever (which shows up as an infinite loading spinner).
            w.onerror = (e) => {
                const msg = (e && e.message) ? e.message : 'worker script failed to load';
                console.error('[kotlin-harfbuzz] worker error:',
                    msg, e && e.filename, e && e.lineno);
                handleWorkerError('HarfBuzz worker error: ' + msg);
            };
            w.onmessageerror = (e) => {
                console.error('[kotlin-harfbuzz] worker message error:', e);
                handleWorkerError('HarfBuzz worker message error');
            };
            return w;
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.__convertKotlinClosureToJsClosure_4' : (f, trampoline) => getCachedJsObject(f, (p0, p1, p2, p3) => trampoline(f, p0, p1, p2, p3)),
    'com.mohamedrejeb.harfbuzz.core.jsGetIntField' : (o, k) => { const v = (o == null ? 0 : o[k]); return v == null ? 0 : (v | 0); },
    'com.mohamedrejeb.harfbuzz.core.jsGetFloatField' : (o, k) => { const v = (o == null ? 0 : o[k]); return v == null ? 0 : +v; },
    'com.mohamedrejeb.harfbuzz.core.buildDestroyFacePayload' : (faceId) => ({ faceId: faceId | 0 }),
    'com.mohamedrejeb.harfbuzz.core.jsExtractCreateFaceTransfer' : (payload) => payload.bytes.buffer,
    'com.mohamedrejeb.harfbuzz.core.buildFontSizePayload' : 
        (fontId, sizePx) => ({ fontId: fontId | 0, sizePx: +sizePx })
        ,
    'com.mohamedrejeb.harfbuzz.core.buildGlyphIdForCodepointPayload' : 
        (fontId, codepoint) => ({ fontId: fontId | 0, codepoint: codepoint | 0 })
        ,
    'com.mohamedrejeb.harfbuzz.core.buildGlyphIdPayload' : 
        (fontId, gid, sizePx) => ({
            fontId: fontId | 0,
            gid: gid | 0,
            sizePx: +sizePx
        })
        ,
    'com.mohamedrejeb.harfbuzz.core.jsGetStringField' : (o, k) => { const v = (o == null ? '' : o[k]); return v == null ? '' : String(v); },
    'com.mohamedrejeb.harfbuzz.core.jsGetField' : (o, k) => (o == null ? null : o[k]),
    'com.mohamedrejeb.harfbuzz.core.buildDestroyFontPayload' : (fontId) => ({ fontId: fontId | 0 }),
    'com.mohamedrejeb.harfbuzz.core.jsGetMapStringByKey' : 
        (map, gid) => {
            if (map == null) return null;
            const v = map[gid];
            return v == null ? null : String(v);
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsGetMapEntryByKey' : (map, gid) => (map == null ? null : map[gid] == null ? null : map[gid]),
    'com.mohamedrejeb.harfbuzz.core.jsBuildBuildMeasuredPayload' : 
        (fontIds, sizePx, text, baseDirection, language,
         featureTags, featureValues, featureStarts, featureEnds, featureCount,
         bidiStarts, bidiEnds, bidiIsRtl, bidiCount,
         perFontFlags) => {
            const features = [];
            for (let i = 0; i < featureCount; i++) {
                features.push({
                    tag: featureTagToString(featureTags[i] >>> 0),
                    value: featureValues[i] | 0,
                    start: featureStarts[i] | 0,
                    end: featureEnds[i] | 0
                });
            }
            const bidiRuns = [];
            for (let i = 0; i < bidiCount; i++) {
                bidiRuns.push({
                    start: bidiStarts[i] | 0,
                    end: bidiEnds[i] | 0,
                    isRtl: !!bidiIsRtl[i]
                });
            }
            const fontStack = [];
            for (let i = 0; i < fontIds.length; i++) fontStack.push(fontIds[i] | 0);
            const flagsArr = [];
            for (let i = 0; i < fontIds.length; i++) {
                const bits = perFontFlags[i] | 0;
                flagsArr.push({
                    flippedPath: (bits & 0x01) !== 0,
                    rawPath:     (bits & 0x02) !== 0,
                    colorLayers: (bits & 0x04) !== 0,
                    paintTree:   (bits & 0x08) !== 0,
                    svg:         (bits & 0x10) !== 0,
                });
            }
            return {
                fontStack,
                sizePx: +sizePx,
                text: String(text),
                baseDirection: String(baseDirection),
                language: String(language),
                features,
                bidiRuns,
                perFontFlags: flagsArr,
            };

            function featureTagToString(tag) {
                return String.fromCharCode(
                    (tag >> 24) & 0xFF,
                    (tag >> 16) & 0xFF,
                    (tag >> 8) & 0xFF,
                    tag & 0xFF
                );
            }
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsBuildCreateFontPayload' : 
        (faceId, sizePx, varTags, varValues, count, embolden, slant) => {
            const variations = [];
            for (let i = 0; i < count; i++) {
                variations.push({ tag: varTags[i] >>> 0, value: varValues[i] });
            }
            return { faceId: faceId | 0, sizePx: +sizePx, variations: variations, embolden: +embolden, slant: +slant };
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsBuildCreateFacePayload' : 
        (bytes, index) => ({ bytes: bytes, index: index | 0 })
        ,
    'com.mohamedrejeb.harfbuzz.core.jsPackAxesArray' : 
        (axes) => {
            if (!axes) return new Float32Array(0);
            const out = new Float32Array(axes.length * 5);
            const f32view = new Float32Array(1);
            const i32view = new Int32Array(f32view.buffer);
            for (let i = 0; i < axes.length; i++) {
                const a = axes[i];
                i32view[0] = (a.tag >>> 0) | 0;
                out[i * 5 + 0] = f32view[0];
                out[i * 5 + 1] = +a.defaultValue;
                out[i * 5 + 2] = +a.minValue;
                out[i * 5 + 3] = +a.maxValue;
                i32view[0] = a.hidden ? 1 : 0;
                out[i * 5 + 4] = f32view[0];
            }
            return out;
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsBuildShapeRunPayload' : 
        (fontId, sizePx, text, direction, scriptTag, language, featureTags, featureValues, featureStarts, featureEnds, count, itemOffset, itemLength) => {
            const features = [];
            for (let i = 0; i < count; i++) {
                features.push({
                    tag: featureTagToString(featureTags[i] >>> 0),
                    value: featureValues[i] | 0,
                    start: featureStarts[i] | 0,
                    end: featureEnds[i] | 0
                });
            }
            return {
                fontId: fontId | 0,
                sizePx: +sizePx,
                text: String(text),
                direction: String(direction),
                scriptTag: scriptTag | 0,
                language: String(language),
                features: features,
                itemOffset: itemOffset | 0,
                itemLength: itemLength | 0
            };

            function featureTagToString(tag) {
                return String.fromCharCode(
                    (tag >> 24) & 0xFF,
                    (tag >> 16) & 0xFF,
                    (tag >> 8) & 0xFF,
                    tag & 0xFF
                );
            }
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsBuildShapeParagraphPayload' : 
        (fontId, sizePx, text, baseDirection, language, featureTags, featureValues, featureStarts, featureEnds, featureCount,
         bidiStarts, bidiEnds, bidiIsRtl, bidiCount) => {
            const features = [];
            for (let i = 0; i < featureCount; i++) {
                features.push({
                    tag: featureTagToString(featureTags[i] >>> 0),
                    value: featureValues[i] | 0,
                    start: featureStarts[i] | 0,
                    end: featureEnds[i] | 0
                });
            }
            const bidiRuns = [];
            for (let i = 0; i < bidiCount; i++) {
                bidiRuns.push({
                    start: bidiStarts[i] | 0,
                    end: bidiEnds[i] | 0,
                    isRtl: !!bidiIsRtl[i]
                });
            }
            return {
                fontStack: [fontId | 0],
                sizePx: +sizePx,
                text: String(text),
                baseDirection: String(baseDirection),
                features: features,
                language: String(language),
                bidiRuns: bidiRuns
            };

            function featureTagToString(tag) {
                return String.fromCharCode(
                    (tag >> 24) & 0xFF,
                    (tag >> 16) & 0xFF,
                    (tag >> 8) & 0xFF,
                    tag & 0xFF
                );
            }
        }
        ,
    'com.mohamedrejeb.harfbuzz.core.jsBuildSnapshotGlyphsPayload' : 
        (fontId, sizePx, gids, flippedPath, rawPath, colorLayers, paintTree, svg) => ({
            fontId: fontId | 0,
            sizePx: +sizePx,
            gids: Array.from(gids),
            flags: {
                flippedPath: !!flippedPath,
                rawPath: !!rawPath,
                colorLayers: !!colorLayers,
                paintTree: !!paintTree,
                svg: !!svg
            }
        })
        ,
    'com.mohamedrejeb.harfbuzz.compose.jsCloseImageBitmap' : (bm) => { try { bm.close(); } catch (_e) {} },
    'com.mohamedrejeb.harfbuzz.compose.jsCreateImageBitmapFromSvgRaw' : 
        (uint8Array, onSuccess, onError) => {
            // Chrome 147+ rejects createImageBitmap(svgBlob) with
            // InvalidStateError ("source image could not be decoded"). Going
            // through an <img> element with a blob URL is the reliable path:
            // the browser's HTML image pipeline accepts SVG, and the loaded
            // <img> is a valid createImageBitmap source.
            try {
                const blob = new Blob([uint8Array], { type: 'image/svg+xml' });
                const url = URL.createObjectURL(blob);
                const img = new Image();
                img.onload = () => {
                    createImageBitmap(img).then(
                        (bm) => { URL.revokeObjectURL(url); onSuccess(bm); },
                        (_e) => { URL.revokeObjectURL(url); onError(); }
                    );
                };
                img.onerror = () => { URL.revokeObjectURL(url); onError(); };
                img.src = url;
            } catch (_e) {
                onError();
            }
        }
        ,
    'com.mohamedrejeb.harfbuzz.compose.jsExtractPixelsFromImageBitmapRaw' : 
        (imageBitmap, w, h) => {
            const canvas = new OffscreenCanvas(w, h);
            const ctx = canvas.getContext('2d');
            if (!ctx) return null;
            ctx.drawImage(imageBitmap, 0, 0);
            return new Uint8Array(ctx.getImageData(0, 0, w, h).data.buffer);
        }
        ,
    'com.mohamedrejeb.harfbuzz.compose.jsAllocFreshUint8Array' : 
        (srcAddr, len) => {
            const buf = new ArrayBuffer(len);
            if (len > 0) {
                new Uint8Array(buf).set(
                    new Uint8Array(wasmExports.memory.buffer, srcAddr, len)
                );
            }
            return new Uint8Array(buf);
        }
        ,
    'com.mohamedrejeb.harfbuzz.compose.jsTypedArrayLength' : (arr) => arr.length,
    'com.mohamedrejeb.harfbuzz.compose.jsCopyUint8ArrayToWasmMemory' : 
        (arr, dstAddr) => {
            const n = arr.length;
            if (n > 0) {
                new Uint8Array(wasmExports.memory.buffer, dstAddr, n).set(arr);
            }
        }
        ,
    'com.mohamedrejeb.richeditor.clipboard.setClipboardData' : (event, format, data) => { event.clipboardData && event.clipboardData.setData(format, data) },
    'com.mohamedrejeb.richeditor.clipboard.getClipboardData' : (event, format) => event.clipboardData && event.clipboardData.getData(format),
    'com.mohamedrejeb.richeditor.clipboard.getBlobText' : (blob) => blob.text(),
    'com.mohamedrejeb.richeditor.clipboard.createTextClipboardItem' : (text) => 
        [new ClipboardItem({
            'text/plain': new Blob([text], { type: 'text/plain' })
        })]
        ,
    'com.mohamedrejeb.richeditor.clipboard.createHtmlClipboardItem' : (html, text) => 
        [new ClipboardItem({
            'text/html': new Blob([html], { type: 'text/html' }),
            'text/plain': new Blob([text], { type: 'text/plain' })
        })]
        ,
    'com.mohamedrejeb.calf.share.jsIsShareSupported' : function() { return ('share' in navigator); },
    'com.mohamedrejeb.calf.share.jsShareText' : 
    function(text, title, onSuccess, onDismissed, onError) {
        var data = { text: text };
        if (title) data.title = title;
        navigator.share(data).then(function() {
            onSuccess();
        }).catch(function(e) {
            if (e && e.name === 'AbortError') { onDismissed(); } else { onError(); }
        });
    }
    ,
    'com.mohamedrejeb.calf.share.jsCopyToClipboard' : function(text) { navigator.clipboard.writeText(text); },
    'com.mohamedrejeb.calf.share.jsShareUrl' : 
    function(url, title, onSuccess, onDismissed, onError) {
        var data = { url: url };
        if (title) data.title = title;
        navigator.share(data).then(function() {
            onSuccess();
        }).catch(function(e) {
            if (e && e.name === 'AbortError') { onDismissed(); } else { onError(); }
        });
    }
    ,
    'com.mohamedrejeb.calf.share.jsShareFile' : 
    function(file, onSuccess, onDismissed, onError) {
        navigator.share({ files: [file] }).then(function() {
            onSuccess();
        }).catch(function(e) {
            if (e && e.name === 'AbortError') { onDismissed(); } else { onError(); }
        });
    }
    ,
    'com.mohamedrejeb.calf.share.jsArrayPush' : function(array, item) { array.push(item); },
    'com.mohamedrejeb.calf.share.jsShareFiles' : 
    function(files, onSuccess, onDismissed, onError) {
        navigator.share({ files: Array.from(files) }).then(function() {
            onSuccess();
        }).catch(function(e) {
            if (e && e.name === 'AbortError') { onDismissed(); } else { onError(); }
        });
    }
    ,
    'com.andalusi.editor.clipboard.jsObjectOf' : (key, value) => ({ [key]: value }),
    'com.andalusi.editor.clipboard.newClipboardItem' : (options) => new ClipboardItem(options),
    'com.andalusi.editor.clipboard.jsSingleElementArray' : (element) => [element],
    'com.andalusi.editor.clipboard.clipboardWrite' : (items) => navigator.clipboard.write(items),
    'com.andalusi.editor.clipboard.jsObjectOf_1' : (key1, value1, key2, value2) => ({ [key1]: value1, [key2]: value2 }),
    'com.andalusi.editor.clipboard.clipboardRead' : () => navigator.clipboard.read(),
    'com.andalusi.editor.clipboard.clipboardItemTypes' : (item) => item.types,
    'com.andalusi.editor.clipboard.clipboardItemGetType' : (item, type) => item.getType(type),
    'com.andalusi.editor.clipboard.blobText' : (blob) => blob.text(),
    'com.andalusi.editor.clipboard.blobArrayBuffer' : (blob) => blob.arrayBuffer(),
    'com.andalusi.editor.clipboard.clipboardReadText' : () => navigator.clipboard.readText(),
    'com.andalusi.editor.clipboard.pngBlobOf' : (blob) => (async () => {
            const bitmap = await createImageBitmap(blob);
            const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
            canvas.getContext('2d').drawImage(bitmap, 0, 0);
            bitmap.close();
            return canvas.convertToBlob({ type: 'image/png' });
        })(),
    'com.andalusi.editor.export.newPieces' : () => ([]),
    'com.andalusi.editor.export.gifFrameRequest' : (id, pixels, width, height, bgra, delayMillis, first) => ({ id: id, pixels: pixels, width: width, height: height, bgra: bgra, delay: delayMillis, first: first }),
    'com.andalusi.editor.export.putPiece' : (pieces, index, piece) => { pieces[index] = piece; },
    'com.andalusi.editor.export.pageTurn' : () => new Promise((next) => {
                const channel = new MessageChannel();
                channel.port1.onmessage = () => { channel.port1.close(); next(null); };
                channel.port2.postMessage(null);
            }),
    'com.andalusi.editor.export.gifFile' : (pieces, mime) => (() => {
                for (let i = 0; i < pieces.length; i++) {
                    if (!pieces[i]) throw new Error('frame ' + i + ' of the gif is missing');
                }
                return new Blob([...pieces, new Uint8Array([0x3B])], { type: mime });
            })(),
    'com.andalusi.editor.export.dropPieces' : (pieces) => { pieces.length = 0; },
    'com.andalusi.editor.export.skikoMemory' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'com.andalusi.editor.export.copyOf' : (memory, address, length) => memory.slice(address, address + length),
    'com.andalusi.editor.export.cores' : () => navigator.hardwareConcurrency || 0,
    'com.andalusi.editor.export.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'com.andalusi.editor.export.loadMediabunny' : () => import(
                /* webpackChunkName: "video-muxer" */
                /* webpackExports: ["Output", "Mp4OutputFormat", "WebMOutputFormat", "BufferTarget", "EncodedVideoPacketSource", "EncodedAudioPacketSource", "EncodedPacket", "Input", "BlobSource", "ALL_FORMATS", "VideoSampleSink", "AudioBufferSink"] */
                'mediabunny'
            ),
    'com.andalusi.editor.export.skikoMemory_1' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'com.andalusi.editor.export.writeFrame' : (state, memory, address, width, height, pixelFormat, index, keyFrame) => (async () => {
                if (state.error) throw state.error;
                // The frame copies the pixels, so the bitmap is free once this returns.
                const frame = new VideoFrame(new Uint8Array(memory, address, width * height * 4), {
                    format: pixelFormat, codedWidth: width, codedHeight: height,
                    timestamp: Math.round(index * 1e6 / state.fps),
                    duration: Math.round(1e6 / state.fps),
                });
                try {
                    state.encoder.encode(frame, { keyFrame: keyFrame });
                } finally {
                    frame.close();
                }
                while (state.encoder.encodeQueueSize > 2 && !state.error) {
                    await new Promise((wake) => { state.wake = wake; setTimeout(wake, 10); });
                }
                state.wake = null;
                // A turn for the page: a task of its own for every frame.
                await new Promise((next) => {
                    const channel = new MessageChannel();
                    channel.port1.onmessage = () => { channel.port1.close(); next(); };
                    channel.port2.postMessage(null);
                });
                if (state.error) throw state.error;
                return null;
            })(),
    'com.andalusi.editor.export.finishFile' : (state) => (async () => {
                await state.encoder.flush();
                state.encoder.close();
                await state.packets;
                if (state.error) throw state.error;
                await state.output.finalize();
                return new Uint8Array(state.output.target.buffer);
            })(),
    'com.andalusi.editor.export.abortFile' : (state) => (() => {
                if (state.encoder && state.encoder.state !== 'closed') state.encoder.close();
                state.output.cancel().catch(() => {});
            })(),
    'com.andalusi.editor.export.createFile' : (muxer, webm, muxerCodec, fps) => (() => {
                const format = webm ? new muxer.WebMOutputFormat() : new muxer.Mp4OutputFormat();
                const output = new muxer.Output({ format: format, target: new muxer.BufferTarget() });
                const source = new muxer.EncodedVideoPacketSource(muxerCodec);
                output.addVideoTrack(source, { frameRate: fps });
                return { muxer, output, source, fps, error: null, packets: Promise.resolve(), wake: null, sound: null };
            })(),
    'com.andalusi.editor.export.mixSounds' : (sounds, sampleRate) => (() => {
                const channels = Math.max(...sounds.map((sound) => sound.channels));
                const length = Math.max(...sounds.map((sound) => sound.reelStart + sound.planes[0].length));
                const planes = Array.from({ length: channels }, () => new Float32Array(length));
                for (const sound of sounds) {
                    for (let channel = 0; channel < channels; channel++) {
                        const from = sound.planes[Math.min(channel, sound.channels - 1)];
                        const to = planes[channel];
                        const base = sound.reelStart;
                        const volume = sound.volume;
                        for (let i = 0; i < from.length; i++) to[base + i] += from[i] * volume;
                    }
                }
                for (const plane of planes) {
                    for (let i = 0; i < plane.length; i++) plane[i] = Math.max(-1, Math.min(1, plane[i]));
                }
                return { planes, channels, length, sampleRate };
            })(),
    'com.andalusi.editor.export.encoderDelay' : (config) => (async () => {
                if (typeof AudioDecoder !== 'function') return 0;
                const rate = config.sampleRate, channels = config.numberOfChannels;
                const total = 8192, burstAt = 4096, burst = 256;
                const chunks = [];
                let decoderConfig = null;
                let error = null;
                const encoder = new AudioEncoder({
                    output: (chunk, meta) => { chunks.push(chunk); if (meta && meta.decoderConfig) decoderConfig = meta.decoderConfig; },
                    error: (failure) => { error = error || failure; },
                });
                encoder.configure(config);
                const samples = new Float32Array(total * channels);
                for (let channel = 0; channel < channels; channel++) {
                    for (let i = 0; i < burst; i++) samples[channel * total + burstAt + i] = Math.sin((i + 1) * 0.7) * 0.9;
                }
                const data = new AudioData({
                    format: 'f32-planar', sampleRate: rate, numberOfFrames: total, numberOfChannels: channels, timestamp: 0, data: samples,
                });
                try {
                    encoder.encode(data);
                } finally {
                    data.close();
                }
                await encoder.flush();
                encoder.close();
                if (error || !decoderConfig) return 0;
                const decoded = [];
                const decoder = new AudioDecoder({ output: (frame) => decoded.push(frame), error: (failure) => { error = error || failure; } });
                decoder.configure(decoderConfig);
                for (const chunk of chunks) decoder.decode(chunk);
                await decoder.flush();
                decoder.close();
                let position = 0;
                let found = -1;
                for (const frame of decoded) {
                    const count = frame.numberOfFrames;
                    if (found < 0) {
                        const plane = new Float32Array(count);
                        frame.copyTo(plane, { planeIndex: 0, format: 'f32-planar' });
                        for (let i = 0; i < count; i++) if (Math.abs(plane[i]) > 0.25) { found = position + i; break; }
                    }
                    frame.close();
                    position += count;
                }
                return error || found < 0 ? 0 : Math.max(0, found - burstAt);
            })(),
    'com.andalusi.editor.export.configOf' : (prepared) => prepared.config,
    'com.andalusi.editor.export.addSoundTrack' : (state, prepared, delay) => (() => {
                if (prepared.length <= delay) {
                    console.warn('sound not exported: the sound ends inside the delay of the encoder');
                    return false;
                }
                const source = new state.muxer.EncodedAudioPacketSource(prepared.muxerCodec);
                state.output.addAudioTrack(source);
                state.sound = { ...prepared, source, delay };
                return true;
            })(),
    'com.andalusi.editor.export.startFile' : (state, codec, width, height, fps, bitRate) => (async () => {
                await state.output.start();
                const fail = (error) => {
                    state.error = state.error || error;
                    if (state.wake) state.wake();
                };
                state.encoder = new VideoEncoder({
                    output: (chunk, meta) => {
                        state.packets = state.packets
                            .then(() => state.source.add(state.muxer.EncodedPacket.fromEncodedChunk(chunk), meta))
                            .catch(fail);
                    },
                    error: fail,
                });
                state.encoder.ondequeue = () => { if (state.wake) state.wake(); };
                // Safari refuses an avc1 codec string handed over from wasm; the same text rebuilt in
                // JavaScript is accepted.
                state.encoder.configure({
                    codec: Array.from(codec).join(''), width: width, height: height, framerate: fps, bitrate: bitRate,
                    ...(codec.startsWith('avc1') ? { avc: { format: 'avc' } } : {}),
                });
                return null;
            })(),
    'com.andalusi.editor.export.writeSound' : (state) => (async () => {
                const { planes, channels, config, source, length, delay } = state.sound;
                state.sound = null;
                const rate = config.sampleRate;
                let error = null;
                let packets = Promise.resolve();
                // Safari describes its AAC with the whole MPEG-4 ES descriptor where WebCodecs asks for the
                // AudioSpecificConfig inside it, and a file written with the descriptor has no sound a player
                // can decode. An AudioSpecificConfig never starts with the descriptor's tag.
                const withAudioSpecificConfig = (meta) => {
                    const decoderConfig = meta && meta.decoderConfig;
                    const description = decoderConfig && decoderConfig.description;
                    if (!description) return meta;
                    const bytes = ArrayBuffer.isView(description)
                        ? new Uint8Array(description.buffer, description.byteOffset, description.byteLength)
                        : new Uint8Array(description);
                    if (bytes[0] !== 0x03) return meta;
                    let at = 1;
                    const size = () => {
                        let value = 0, byte;
                        do { byte = bytes[at++]; value = (value << 7) | (byte & 0x7f); } while (byte & 0x80);
                        return value;
                    };
                    size(); at += 3;
                    if (bytes[at++] !== 0x04) return meta;
                    size(); at += 13;
                    if (bytes[at++] !== 0x05) return meta;
                    const length = size();
                    return { ...meta, decoderConfig: { ...decoderConfig, description: bytes.slice(at, at + length) } };
                };
                const encoder = new AudioEncoder({
                    output: (chunk, meta) => {
                        const described = withAudioSpecificConfig(meta);
                        packets = packets
                            .then(() => source.add(state.muxer.EncodedPacket.fromEncodedChunk(chunk), described))
                            .catch((failure) => { error = error || failure; });
                    },
                    error: (failure) => { error = error || failure; },
                });
                encoder.configure(config);
                const piece = rate / 10;
                for (let at = delay; at < length; at += piece) {
                    const count = Math.min(piece, length - at);
                    const samples = new Float32Array(count * channels);
                    for (let channel = 0; channel < channels; channel++) {
                        samples.set(planes[channel].subarray(at, at + count), channel * count);
                    }
                    const data = new AudioData({
                        format: 'f32-planar', sampleRate: rate, numberOfFrames: count, numberOfChannels: channels,
                        timestamp: Math.round((at - delay) * 1e6 / rate), data: samples,
                    });
                    try {
                        encoder.encode(data);
                    } finally {
                        data.close();
                    }
                    while (encoder.encodeQueueSize > 8 && !error) {
                        await new Promise((next) => setTimeout(next, 5));
                    }
                    if (error) throw error;
                }
                await encoder.flush();
                encoder.close();
                await packets;
                if (error) throw error;
                return null;
            })(),
    'com.andalusi.editor.export.consoleWarn' : (message) => console.warn(message),
    'com.andalusi.editor.export.decodeSound' : (muxer, blob, sourceStart, seconds, sampleRate) => (async () => {
                const length = Math.ceil(seconds * sampleRate);
                if (length <= 0) return null;
                const planesOf = (rendered, channels) => ({ planes: Array.from({ length: channels }, (_, channel) => rendered.getChannelData(channel)), channels });
                const input = new muxer.Input({ source: new muxer.BlobSource(blob), formats: muxer.ALL_FORMATS });
                try {
                    if (!(await input.getPrimaryVideoTrack())) {
                        let decoded;
                        try {
                            // An offline context decodes at its own rate, whatever the output of the machine runs at.
                            decoded = await new OfflineAudioContext(1, 1, sampleRate).decodeAudioData(await blob.arrayBuffer());
                        } catch (error) {
                            console.warn('sound not exported: the soundtrack cannot be decoded, ' + error);
                            return null;
                        }
                        const channels = Math.min(decoded.numberOfChannels, 2);
                        const from = Math.round(sourceStart * sampleRate);
                        const planes = Array.from({ length: channels }, (_, channel) => {
                            const plane = new Float32Array(length);
                            plane.set(decoded.getChannelData(channel).subarray(from, from + length));
                            return plane;
                        });
                        return { planes, channels };
                    }
                    const track = await input.getPrimaryAudioTrack();
                    if (!track) {
                        console.warn('sound not exported: the video has no audio track');
                        return null;
                    }
                    if (!(await track.canDecode())) {
                        console.warn('sound not exported: this browser decodes no ' + track.codec);
                        return null;
                    }
                    const pieces = [];
                    for await (const piece of new muxer.AudioBufferSink(track).buffers(sourceStart, sourceStart + seconds)) {
                        pieces.push(piece);
                    }
                    if (pieces.length === 0) return null;
                    // One buffer at the file's rate, so the resampler sees a continuous signal, not seams every packet.
                    const rate = pieces[0].buffer.sampleRate;
                    const channels = Math.min(pieces[0].buffer.numberOfChannels, 2);
                    const first = pieces[0].timestamp;
                    const last = pieces[pieces.length - 1];
                    const whole = new AudioBuffer({
                        numberOfChannels: channels, sampleRate: rate,
                        length: Math.round((last.timestamp - first) * rate) + last.buffer.length,
                    });
                    for (const piece of pieces) {
                        const at = Math.round((piece.timestamp - first) * rate);
                        for (let channel = 0; channel < channels; channel++) {
                            whole.copyToChannel(piece.buffer.getChannelData(Math.min(channel, piece.buffer.numberOfChannels - 1)), channel, at);
                        }
                    }
                    const context = new OfflineAudioContext(channels, length, sampleRate);
                    const node = context.createBufferSource();
                    node.buffer = whole;
                    node.connect(context.destination);
                    const offset = first - sourceStart;
                    if (offset >= 0) node.start(offset); else node.start(0, -offset);
                    return planesOf(await context.startRendering(), channels);
                } finally {
                    input.dispose();
                }
            })(),
    'com.andalusi.editor.export.soundOnReel' : (decoded, reelStart, volume) => ({ planes: decoded.planes, channels: decoded.channels, reelStart, volume }),
    'com.andalusi.editor.export.prepareSound' : (mix, codec, muxerCodec, bitRate) => (async () => {
                if (typeof AudioEncoder !== 'function' || typeof AudioData !== 'function') {
                    console.warn('sound not exported: this browser encodes no audio');
                    return null;
                }
                const config = {
                    codec: codec, sampleRate: mix.sampleRate, numberOfChannels: mix.channels, bitrate: bitRate,
                    ...(codec.startsWith('mp4a') ? { aac: { format: 'aac' } } : { opus: { format: 'opus' } }),
                };
                const support = await AudioEncoder.isConfigSupported(config).catch(() => ({ supported: false }));
                if (!support.supported) {
                    console.warn('sound not exported: this browser encodes no ' + codec);
                    return null;
                }
                return { planes: mix.planes, channels: mix.channels, length: mix.length, config, muxerCodec };
            })(),
    'com.andalusi.editor.export.motion.openFrameStream' : (muxer, blob) => (async () => {
                const input = new muxer.Input({ source: new muxer.BlobSource(blob), formats: muxer.ALL_FORMATS });
                const track = await input.getPrimaryVideoTrack();
                if (!track || !(await track.canDecode())) {
                    input.dispose();
                    return null;
                }
                const width = track.displayWidth, height = track.displayHeight;
                const canvas = new OffscreenCanvas(width, height);
                const context = canvas.getContext('2d');
                const sink = new muxer.VideoSampleSink(track);
                return { input, sink, canvas, context, width, height, iterator: null, current: null, next: null, drawnSample: null, drawn: 0 };
            })(),
    'com.andalusi.editor.export.motion.consoleWarn' : (message) => console.warn(message),
    'com.andalusi.editor.export.motion.seekFrame' : (stream, seconds) => (async () => {
                const s = stream;
                const pull = async () => { const r = await s.iterator.next(); return r.done ? null : r.value; };
                if (!s.iterator || (s.current && seconds < s.current.timestamp - 1e-6)) {
                    if (s.current) s.current.close();
                    if (s.next) s.next.close();
                    if (s.iterator) await s.iterator.return();
                    s.iterator = s.sink.samples(Math.max(0, seconds));
                    s.current = await pull();
                    s.next = s.current ? await pull() : null;
                }
                while (s.next && s.next.timestamp <= seconds + 1e-6) {
                    s.current.close();
                    s.current = s.next;
                    s.next = await pull();
                }
                let sample = s.current;
                if (sample && s.next && s.next.timestamp - seconds < seconds - sample.timestamp) sample = s.next;
                if (!sample) return -1;
                if (s.drawnSample !== sample) {
                    sample.draw(s.context, 0, 0, s.width, s.height);
                    s.drawnSample = sample;
                    s.drawn++;
                }
                return s.drawn;
            })(),
    'com.andalusi.editor.export.motion.frameCanvas' : (stream) => stream.canvas,
    'com.andalusi.editor.export.motion.frameWidth' : (stream) => stream.width,
    'com.andalusi.editor.export.motion.frameHeight' : (stream) => stream.height,
    'com.andalusi.editor.export.motion.closeFrameStream' : (stream) => {
                const s = stream;
                if (s.current) s.current.close();
                if (s.next) s.next.close();
                if (s.iterator) s.iterator.return().catch(() => {});
                s.input.dispose();
            },
    'com.andalusi.editor.utils.hasAudioTrack' : (muxer, blob) => (async () => {
                const input = new muxer.Input({ source: new muxer.BlobSource(blob), formats: muxer.ALL_FORMATS });
                try {
                    return (await input.getPrimaryAudioTrack()) !== null;
                } finally {
                    input.dispose();
                }
            })(),
    'feature.user.ui.providers.isFacebookSdkReady' : () => typeof FB !== 'undefined' && !!FB.login,
    'feature.user.ui.providers.injectFacebookSdk' : 
        (appId, locale) => {
            window.fbAsyncInit = () => {
                FB.init({ appId: appId, cookie: false, xfbml: false, version: 'v23.0' });
            };
            const script = document.createElement('script');
            script.src = 'https://connect.facebook.net/' + locale + '/sdk.js';
            script.async = true;
            script.defer = true;
            script.crossOrigin = 'anonymous';
            document.head.appendChild(script);
        }
    ,
    'feature.user.ui.providers.launchFacebookLogin' : 
        (onResponse) => {
            FB.login((response) => {
                const auth = response && response.authResponse;
                onResponse(
                    (response && response.status) || '',
                    (auth && auth.accessToken) || ''
                );
            }, { scope: 'email,public_profile' });
        }
    ,
    'feature.user.ui.providers.launchGoogleCodePopup' : 
        (clientId, onCode, onError) => {
            const client = google.accounts.oauth2.initCodeClient({
                client_id: clientId,
                scope: 'openid email profile',
                ux_mode: 'popup',
                select_account: true,
                callback: (response) => {
                    if (response && response.code) onCode(response.code);
                    else onError((response && response.error) || 'no_code');
                },
                error_callback: (err) => onError((err && err.type) || 'popup_error')
            });
            client.requestCode();
        }
    ,
    'feature.user.ui.providers.isGsiAvailable' : () => typeof google !== 'undefined' && !!(google.accounts && google.accounts.oauth2),
    'app.common.adapty.openCheckoutTab' : (url) => (() => {
            // A host page that draws the store opens the tab itself, in the tap (this frame has no
            // user activation of its own then), and leaves it here for this purchase.
            try {
                const host = window.parent !== window ? window.parent : null;
                const pending = host && host.andalusiCheckout;
                if (pending && pending.url === url && pending.tab && !pending.tab.closed) {
                    host.andalusiCheckout = null;
                    return pending.tab;
                }
            } catch (e) {}
            return window.open(url, '_blank');
        })(),
    'app.common.adapty.closeTab' : (tab) => (function(){ try { if (tab) { tab.close(); } } catch (e) {} if (window && window.focus) { window.focus(); } return true; })(),
    'app.common.adapty.isTabClosed' : (tab) => (tab === null || tab === undefined || tab.closed === true),
    'app.common.adapty.encodeUriComponent' : (value) => encodeURIComponent(value),
    'app.common.analytics.isPageHidden' : () => document.visibilityState === 'hidden',
    'app.common.analytics.browserTimeZone' : () => Intl.DateTimeFormat().resolvedOptions().timeZone,
    'app.common.navigation.browser.refBrowserWindow' : () => window,
    'app.common.navigation.browser.decodeURIComponent_$external_fun' : (p0) => decodeURIComponent(p0),
    'app.common.navigation.browser.location_$external_prop_getter' : (_this) => _this.location,
    'app.common.navigation.browser.history_$external_prop_getter' : (_this) => _this.history,
    'app.common.navigation.browser.console_$external_prop_getter' : (_this) => _this.console,
    'app.common.navigation.browser.state_$external_prop_getter' : (_this) => _this.state,
    'app.common.navigation.browser.pushState_$external_fun' : (_this, p0, p1, p2) => _this.pushState(p0, p1, p2),
    'app.common.navigation.browser.replaceState_$external_fun' : (_this, p0, p1, p2) => _this.replaceState(p0, p1, p2),
    'app.common.navigation.browser.go_$external_fun' : (_this, p0) => _this.go(p0),
    'app.common.navigation.browser.origin_$external_prop_getter' : (_this) => _this.origin,
    'app.common.navigation.browser.hash_$external_prop_getter' : (_this) => _this.hash,
    'app.common.navigation.browser.encodeURIComponent_$external_fun' : (p0) => encodeURIComponent(p0),
    'app.common.navigation.browser.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'app.common.navigation.browser.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'app.common.navigation.browser.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'app.common.navigation.browser.state_$external_prop_getter_1' : (_this) => _this.state,
    'org.jetbrains.compose.web.internal.runtime.browserDocument_$external_prop_getter' : () => document,
    'org.jetbrains.compose.web.internal.createJsWeakMap' : () => new WeakMap(),
    'org.jetbrains.compose.web.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.web.internal.has_$external_fun' : (_this, p0) => _this.has(p0),
    'org.jetbrains.compose.web.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'org.jetbrains.compose.web.internal.movementX_$external_prop_getter' : (_this) => _this.movementX,
    'org.jetbrains.compose.web.internal.movementY_$external_prop_getter' : (_this) => _this.movementY,
    'org.jetbrains.compose.web.internal.locale_$external_prop_getter' : (_this) => _this.locale,
    'org.jetbrains.compose.web.internal.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'org.jetbrains.compose.web.internal.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.jetbrains.compose.web.internal.data_$external_prop_getter' : (_this) => _this.data,
    'org.jetbrains.compose.web.internal.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.jetbrains.compose.web.internal.value_$external_prop_getter' : (_this) => _this.value,
    'org.jetbrains.compose.web.internal.checked_$external_prop_getter' : (_this) => _this.checked,
    'org.jetbrains.compose.web.internal.valueAsNumber_$external_prop_getter' : (_this) => _this.valueAsNumber,
    'app.web.overrideNavigatorLanguage' : (language) => {
            Object.defineProperty(window.navigator, 'language', { get: () => language, configurable: true });
            Object.defineProperty(window.navigator, 'languages', { get: () => [language], configurable: true });
        },
    'app.web.sendKeepAliveDelete' : (url, token, body) => {
            fetch(url, {
                method: 'DELETE',
                keepalive: true,
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: body
            }).catch(() => {});
        },
    'app.web.analytics.newJsObject' : () => ({}),
    'app.web.analytics.setJsProperty' : (target, key, value) => target[key] = value,
    'app.web.dragdrop.draggedKind' : (event, videos, editorOpen) => (() => {
            const dt = event.dataTransfer;
            if (!dt) return null;
            let hasFiles = false;
            for (const item of Array.from(dt.items || [])) {
                if (item.kind !== 'file') continue;
                hasFiles = true;
                if (item.type.startsWith('image/')) return 'image';
                if (videos && item.type.startsWith('video/')) return 'video';
                if (item.type === '') return 'project';
                if (editorOpen && item.type.startsWith('audio/')) return 'sound';
                if (editorOpen && /font|opentype/.test(item.type)) return 'font';
            }
            if (hasFiles) return 'refused';
            const types = Array.from(dt.types || []);
            if (types.includes('Files')) return 'file';
            return types.includes('text/uri-list') ? 'image' : null;
        })(),
    'app.web.dragdrop.mouseButtons' : (event) => event.buttons ?? 0,
    'app.web.dragdrop.blockStalePointerEnter' : (pointerOver) => pointerOver.composedPath()[0].addEventListener('pointerenter', (e) => { if (e.buttons) e.stopImmediatePropagation() }, { capture: true, once: true }),
    'app.web.dragdrop.setDropOverlay' : (kind) => window.setDropOverlay?.(kind),
    'app.web.firebase.firebaseOptions' : (apiKey, authDomain, projectId, storageBucket, messagingSenderId, appId, measurementId) => ({ apiKey: apiKey, authDomain: authDomain, projectId: projectId, storageBucket: storageBucket, messagingSenderId: messagingSenderId, appId: appId, measurementId: measurementId }),
    'app.web.hideAppLoader' : () => window.hideAppLoader?.(),
    'app.web.perf.installSpikeEntryPoint' : (run) => window.andalusiGpuSpike = run,
    'app.web.perf.publishResult' : (json) => window.andalusiGpuSpikeResult = json,
    'app.web.perf.webGl2Attributes' : () => ({ majorVersion: 2, alpha: 1, depth: 1, stencil: 8, antialias: 0, premultipliedAlpha: 1, preserveDrawingBuffer: 0, enableExtensionsByDefault: 1 }),
    'app.web.shell.animateCard' : (card, originX, originY, originWidth, reverse, onEnd) => (() => {
            const box = card.getBoundingClientRect();
            if (box.width === 0) { onEnd(); return; }
            const fromOrigin = originWidth > 1;
            const scale = fromOrigin ? Math.min(1, Math.max(0.05, originWidth / box.width)) : originWidth;
            card.style.transformOrigin = fromOrigin ? ((originX - box.left) + 'px ' + (originY - box.top) + 'px') : 'center';
            const frames = [{ transform: 'scale(' + scale + ')', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }];
            const animation = card.animate(reverse ? frames.reverse() : frames, { duration: 350, easing: 'ease-out', fill: 'forwards' });
            animation.onfinish = () => onEnd();
        })(),
    'app.web.shell.installCompareDrag' : (element, onFraction) => (() => {
            let dragging = false;
            const report = (e) => {
                const box = element.getBoundingClientRect();
                let f = (e.clientX - box.left) / box.width;
                if (getComputedStyle(element).direction === 'rtl') f = 1 - f;
                onFraction(Math.min(1, Math.max(0, f)));
            };
            const down = (e) => {
                if (e.button !== 0 || e.target.closest('button')) return;
                dragging = true;
                element.setPointerCapture(e.pointerId);
                report(e);
            };
            const move = (e) => { if (dragging) report(e); };
            const up = () => { dragging = false; };
            element.addEventListener('pointerdown', down);
            element.addEventListener('pointermove', move);
            element.addEventListener('pointerup', up);
            element.addEventListener('pointercancel', up);
            return () => {
                element.removeEventListener('pointerdown', down);
                element.removeEventListener('pointermove', move);
                element.removeEventListener('pointerup', up);
                element.removeEventListener('pointercancel', up);
            };
        })(),
    'app.web.shell.scrollToChild' : (row, index) => {
            const child = row.children[index];
            if (child) row.scrollTo({ left: child.offsetLeft - row.firstElementChild.offsetLeft, behavior: 'instant' });
        },
    'app.web.shell.isPhoneWidth' : () => window.matchMedia('(max-width: 719px)').matches,
    'app.web.shell.focusAndSelect' : (element) => setTimeout(() => { element.focus(); element.select(); }, 0),
    'app.web.shell.focusLater' : (element) => setTimeout(() => element.focus({ preventScroll: true }), 0),
    'app.web.shell.isKeyboardClick' : (event) => event.detail === 0,
    'app.web.shell.installPanDrag' : (element, onStart, onMove, onEnd) => (() => {
            let start = null;
            let moved = false;
            const down = (e) => {
                if (e.button !== 0) return;
                e.preventDefault();
                start = { x: e.clientX, y: e.clientY };
                moved = false;
                element.setPointerCapture(e.pointerId);
                onStart();
            };
            const move = (e) => {
                if (start === null) return;
                const dx = e.clientX - start.x;
                const dy = e.clientY - start.y;
                if (Math.abs(dx) >= 4 || Math.abs(dy) >= 4) moved = true;
                if (moved) onMove(dx, dy);
            };
            const up = () => { if (start !== null) { start = null; onEnd(moved); } };
            element.addEventListener('pointerdown', down);
            element.addEventListener('pointermove', move);
            element.addEventListener('pointerup', up);
            element.addEventListener('pointercancel', up);
            return () => {
                element.removeEventListener('pointerdown', down);
                element.removeEventListener('pointermove', move);
                element.removeEventListener('pointerup', up);
                element.removeEventListener('pointercancel', up);
            };
        })(),
    'app.web.shell.installBoxObserver' : (element, onBox) => (() => {
            let last = '';
            const report = () => {
                const r = element.getBoundingClientRect();
                const box = [r.left, r.top, r.width, r.height].map(Math.round);
                const key = box.join(',');
                if (key === last) return;
                last = key;
                onBox(box[0], box[1], box[2], box[3]);
            };
            const observer = new ResizeObserver(report);
            observer.observe(element);
            addEventListener('resize', report);
            report();
            return () => { observer.disconnect(); removeEventListener('resize', report); };
        })(),
    'app.web.shell.loadDotLottie' : () => import(/* webpackChunkName: "dotlottie" */ /* webpackExports: ["DotLottie"] */ '@lottiefiles/dotlottie-web'),
    'app.web.shell.setWasmUrl' : (module, url) => module.DotLottie.setWasmUrl(url),
    'app.web.shell.createPlayer' : (module, canvas, src) => new module.DotLottie({
            canvas: canvas,
            src: src,
            loop: true,
            autoplay: true,
            renderConfig: { freezeOnOffscreen: true, autoResize: true },
        }),
    'app.web.shell.destroyPlayer' : (player) => player.destroy(),
    'app.web.shell.playQuietly' : (video) => video.play().catch(() => {}),
    'app.web.shell.installNearEnd' : (element, onEnd) => (() => {
            const check = () => {
                if (element.scrollHeight - element.scrollTop - element.clientHeight < 400) onEnd();
            };
            element.addEventListener('scroll', check, { passive: true });
            return () => element.removeEventListener('scroll', check);
        })(),
    'app.web.shell.installPageReorder' : (strip, threshold, canStart, onStart, onOver, onEnd) => (() => {
            let press = null;
            let dragging = false;
            let swallow = false;
            let scroll = 0;
            const cells = () => Array.from(strip.querySelectorAll('.page-cell'));
            const over = (x) => {
                const list = cells();
                let best = -1;
                let distance = Infinity;
                list.forEach((cell, index) => {
                    const r = cell.getBoundingClientRect();
                    const d = Math.abs(r.left + r.width / 2 - x);
                    if (d < distance) { distance = d; best = index; }
                });
                if (best >= 0) onOver(best);
            };
            const autoscroll = (x) => {
                cancelAnimationFrame(scroll);
                const box = strip.getBoundingClientRect();
                const edge = 48;
                const speed = x < box.left + edge ? -(box.left + edge - x) : x > box.right - edge ? x - (box.right - edge) : 0;
                if (!dragging || speed === 0) return;
                const step = () => {
                    strip.scrollLeft += speed * 0.4;
                    over(x);
                    scroll = requestAnimationFrame(step);
                };
                scroll = requestAnimationFrame(step);
            };
            const down = (e) => {
                if (e.button !== 0) return;
                const cell = e.target.closest('.page-cell');
                if (!cell || !strip.contains(cell) || !canStart()) return;
                press = { x: e.clientX, y: e.clientY, id: e.pointerId, index: cells().indexOf(cell) };
            };
            const move = (e) => {
                if (!press || e.pointerId !== press.id) return;
                if (!dragging) {
                    if (Math.hypot(e.clientX - press.x, e.clientY - press.y) < threshold) return;
                    dragging = true;
                    strip.setPointerCapture(e.pointerId);
                    strip.classList.add('reordering');
                    onStart(press.index);
                }
                over(e.clientX);
                autoscroll(e.clientX);
            };
            const up = (e) => {
                if (!press || e.pointerId !== press.id) return;
                press = null;
                cancelAnimationFrame(scroll);
                if (!dragging) return;
                dragging = false;
                swallow = true;
                strip.classList.remove('reordering');
                onEnd();
                // The click this release makes, if any, comes right after; drop the flag on the next turn.
                setTimeout(() => { swallow = false; }, 0);
            };
            const click = (e) => {
                if (!swallow) return;
                swallow = false;
                e.stopPropagation();
                e.preventDefault();
            };
            strip.addEventListener('pointerdown', down);
            strip.addEventListener('pointermove', move);
            strip.addEventListener('pointerup', up);
            strip.addEventListener('pointercancel', up);
            strip.addEventListener('click', click, true);
            return () => {
                cancelAnimationFrame(scroll);
                strip.removeEventListener('pointerdown', down);
                strip.removeEventListener('pointermove', move);
                strip.removeEventListener('pointerup', up);
                strip.removeEventListener('pointercancel', up);
                strip.removeEventListener('click', click, true);
            };
        })(),
    'app.web.shell.onPointerDownOutside' : (element, onOutside) => (() => {
            const listener = (e) => { if (!element.contains(e.target)) onOutside(); };
            document.addEventListener('pointerdown', listener, true);
            return () => document.removeEventListener('pointerdown', listener, true);
        })(),
    'app.web.shell.installSizeObserver' : (element, onSize) => (() => {
            const observer = new ResizeObserver(() => onSize(element.offsetWidth, element.offsetHeight));
            observer.observe(element);
            return () => observer.disconnect();
        })(),
    'app.web.shell.objectUrlOf' : (bytes, type) => URL.createObjectURL(new Blob([bytes], { type: type })),
    'app.web.shell.revokeObjectUrl' : (url) => URL.revokeObjectURL(url),
    'app.web.shell.navigateTo' : (url) => window.location.assign(url),
    'app.web.shell.isDomChromeRequested' : () => document.documentElement.classList.contains('dom-chrome'),
    'app.web.shell.showAppScreen' : (show) => document.documentElement.classList.toggle('app-screen', show),
    'app.web.shell.trackContextMenuPoint' : (onPoint) => document.addEventListener('contextmenu', (e) => {
            const root = document.getElementById('compose-root');
            if (root && root.contains(e.target)) onPoint(e.clientX, e.clientY);
        }, true),
    'app.web.shell.installShortcutListener' : (onShortcut) => window.addEventListener('keydown', (e) => {
            const t = e.target;
            const textInput = t && t.tagName === 'INPUT' && !['range', 'color', 'checkbox', 'radio', 'button'].includes(t.type);
            const editing = t && (t.isContentEditable || textInput || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT');
            if (editing) return;
            if (onShortcut(e.key, e.metaKey || e.ctrlKey, e.shiftKey)) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        }, true),
    'app.web.shell.__convertKotlinClosureToJsClosure_3' : (f, trampoline) => getCachedJsObject(f, (p0, p1, p2) => trampoline(f, p0, p1, p2)),
    'app.web.shell.setInnerHtml' : (element, html) => element.innerHTML = html,
    'app.web.shell.pageTitle' : (title) => document.title = title,
    'app.web.shell.perfMark' : (name) => performance.mark(name),
    'app.web.shell.isMac' : () => /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent),
    'app.web.shell.isRightToLeft' : () => document.documentElement.dir === 'rtl',
    'app.web.shell.isDarkPage' : () => document.documentElement.classList.contains('dark'),
    'app.web.shell.installStrip' : (element) => (() => {
            const update = () => {
                const max = element.scrollWidth - element.clientWidth;
                const offset = Math.abs(element.scrollLeft);
                element.toggleAttribute('data-more-start', offset > 1);
                element.toggleAttribute('data-more-end', offset < max - 1);
            };
            const wheel = (e) => {
                if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
                const rtl = getComputedStyle(element).direction === 'rtl';
                element.scrollLeft += rtl ? -e.deltaY : e.deltaY;
                e.preventDefault();
            };
            element.addEventListener('wheel', wheel, { passive: false });
            element.addEventListener('scroll', update, { passive: true });
            const resize = new ResizeObserver(update);
            resize.observe(element);
            const content = new MutationObserver(update);
            content.observe(element, { childList: true, subtree: true, characterData: true });
            update();
            return () => {
                element.removeEventListener('wheel', wheel);
                element.removeEventListener('scroll', update);
                resize.disconnect();
                content.disconnect();
            };
        })(),
    'app.web.shell.runRemover' : (remove) => remove(),
    'app.web.shell.installCentred' : (element, onCentred) => (() => {
            let timer = 0;
            let byUser = false;
            const pick = () => {
                const box = element.getBoundingClientRect();
                const middle = box.left + box.width / 2;
                let best = -1;
                let distance = Infinity;
                element.querySelectorAll('.page-cell').forEach((cell, index) => {
                    const r = cell.getBoundingClientRect();
                    const d = Math.abs(r.left + r.width / 2 - middle);
                    if (d < distance) { distance = d; best = index; }
                });
                if (best >= 0) onCentred(best);
            };
            const mark = () => { byUser = true; };
            const scrolled = () => {
                if (!byUser) return;
                clearTimeout(timer);
                timer = setTimeout(() => { byUser = false; pick(); }, 140);
            };
            element.addEventListener('wheel', mark, { passive: true });
            element.addEventListener('pointerdown', mark);
            element.addEventListener('keydown', mark);
            element.addEventListener('scroll', scrolled, { passive: true });
            return () => {
                clearTimeout(timer);
                element.removeEventListener('wheel', mark);
                element.removeEventListener('pointerdown', mark);
                element.removeEventListener('keydown', mark);
                element.removeEventListener('scroll', scrolled);
            };
        })(),
    'app.web.shell.showPagesPanel' : (show, heightPx) => {
            const root = document.documentElement;
            root.classList.toggle('pages-open', show);
            root.style.setProperty('--pages-h', heightPx + 'px');
        },
    'app.web.shell.watchSheetHeight' : () => {
            const root = document.documentElement;
            let watched = null;
            const sizes = new ResizeObserver((entries) => {
                for (const entry of entries) root.style.setProperty('--sheet-h', Math.round(entry.contentRect.height) + 'px');
            });
            const follow = () => {
                const panel = document.querySelector('#dom-shell .form-panel');
                if (panel === watched) return;
                if (watched) sizes.unobserve(watched);
                watched = panel;
                root.classList.toggle('sheet-open', !!panel);
                if (panel) sizes.observe(panel, { box: 'border-box' });
            };
            new MutationObserver(follow).observe(document.getElementById('dom-shell'), { childList: true, subtree: true });
        },
    'app.web.shell.observeCanvasSlot' : (onGaps) => (() => {
            const slot = document.getElementById('canvas-slot');
            if (!slot) return;
            let last = '';
            const report = () => {
                const r = slot.getBoundingClientRect();
                const gaps = [r.left, r.top, innerWidth - r.right, innerHeight - r.bottom].map((v) => Math.max(0, Math.round(v)));
                const key = gaps.join(',');
                if (key === last) return;
                last = key;
                onGaps(gaps[0], gaps[1], gaps[2], gaps[3]);
            };
            new ResizeObserver(report).observe(slot);
            addEventListener('resize', report);
            report();
        })(),
    'app.web.shell.centerChild' : (container, selector) => {
            const child = container.querySelector(selector);
            if (child) {
                const box = container.getBoundingClientRect();
                const item = child.getBoundingClientRect();
                container.scrollTop += (item.top + item.height / 2) - (box.top + box.height / 2);
                container.scrollLeft += (item.left + item.width / 2) - (box.left + box.width / 2);
            }
        },
    'app.web.shell.isInFrame' : () => window.parent !== window,
    'app.web.shell.tellLobby' : (event, value) => (() => {
            try {
                const lobby = window.parent.andalusiLobby;
                if (lobby && typeof lobby[event] === 'function') lobby[event](value);
            } catch (ignored) {}
        })(),
    'app.web.shell.tellLobbyMirror' : (name, kind, value) => (() => {
            try {
                const lobby = window.parent.andalusiLobby;
                if (lobby && typeof lobby.mirror === 'function') lobby.mirror(name, kind, value);
            } catch (ignored) {}
        })(),
    'app.web.shell.exposeEditorApi' : (open, close, busy, designs, account, screen, back, watch, unwatch, send) => window.andalusiEditor = {
            open: (url) => open(url),
            close: () => close(),
            busy: () => busy(),
            designs: (action, dirs, title, done) => designs(action, dirs, title, done),
            account: (action, done) => account(action, done),
            screen: (name) => screen(name),
            back: () => back(),
            watch: (name) => watch(name),
            unwatch: (name) => unwatch(name),
            send: (name, event, value) => send(name, event, value),
        },
    'app.web.shell.__callJsClosure_((String)->Unit)' : (f, p0) => f(p0),
    'app.web.shell.replaceUrl' : (url) => history.replaceState(null, '', url),
    'app.web.shell.decodeUriComponent' : (value) => (() => { try { return decodeURIComponent(value); } catch (e) { return value; } })(),
    'app.web.shell.takePendingFile' : () => (() => {
            const frame = window.parent.andalusiFrame;
            const file = (frame && frame.pendingFile) || null;
            if (frame) frame.pendingFile = null;
            return file;
        })(),
    'app.web.shell.installTimelineScroll' : (element, scrubs, onScrub, onScrubEnd, onZoom) => (() => {
            let held = false;
            let scrubbing = false;
            let timer = 0;
            const settle = () => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    if (held || !scrubbing) return;
                    scrubbing = false;
                    onScrubEnd();
                }, 140);
            };
            const wheel = (e) => {
                if (e.ctrlKey || e.metaKey) {
                    e.preventDefault();
                    const box = element.getBoundingClientRect();
                    const rtl = getComputedStyle(element).direction === 'rtl';
                    onZoom(Math.exp(-e.deltaY * 0.004), rtl ? box.right - e.clientX : e.clientX - box.left);
                    return;
                }
                if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                    const rtl = getComputedStyle(element).direction === 'rtl';
                    element.scrollLeft += rtl ? -e.deltaY : e.deltaY;
                    e.preventDefault();
                }
            };
            const down = () => { held = true; };
            const up = () => { held = false; settle(); };
            const scrolled = () => {
                if (!scrubs) return;
                const offset = Math.abs(element.scrollLeft);
                const set = element.__timelineSet;
                if (set !== undefined && Math.abs(offset - set) < 1) return;
                element.__timelineSet = undefined;
                scrubbing = true;
                onScrub(offset);
                settle();
            };
            element.addEventListener('wheel', wheel, { passive: false });
            element.addEventListener('pointerdown', down);
            window.addEventListener('pointerup', up);
            window.addEventListener('pointercancel', up);
            element.addEventListener('scroll', scrolled, { passive: true });
            return () => {
                clearTimeout(timer);
                element.removeEventListener('wheel', wheel);
                element.removeEventListener('pointerdown', down);
                window.removeEventListener('pointerup', up);
                window.removeEventListener('pointercancel', up);
                element.removeEventListener('scroll', scrolled);
            };
        })(),
    'app.web.shell.scrollOffset' : (element) => Math.abs(element.scrollLeft),
    'app.web.shell.installScrubDrag' : (zone, content, onScrub, onEnd) => (() => {
            let held = null;
            const at = (e) => {
                const box = content.getBoundingClientRect();
                const rtl = getComputedStyle(content).direction === 'rtl';
                return Math.max(0, rtl ? box.right - e.clientX : e.clientX - box.left);
            };
            const down = (e) => {
                if (e.button !== 0) return;
                e.preventDefault();
                e.stopPropagation();
                held = e.pointerId;
                zone.setPointerCapture(e.pointerId);
                onScrub(at(e));
            };
            const move = (e) => { if (held === e.pointerId) onScrub(at(e)); };
            const up = (e) => {
                if (held !== e.pointerId) return;
                held = null;
                onEnd();
            };
            zone.addEventListener('pointerdown', down);
            zone.addEventListener('pointermove', move);
            zone.addEventListener('pointerup', up);
            zone.addEventListener('pointercancel', up);
            return () => {
                zone.removeEventListener('pointerdown', down);
                zone.removeEventListener('pointermove', move);
                zone.removeEventListener('pointerup', up);
                zone.removeEventListener('pointercancel', up);
            };
        })(),
    'app.web.shell.setScrollOffset' : (element, offset) => {
            element.scrollLeft = getComputedStyle(element).direction === 'rtl' ? -offset : offset;
            element.__timelineSet = Math.abs(element.scrollLeft);
        },
    'app.web.shell.installWidthObserver' : (element, onWidth) => (() => {
            const observer = new ResizeObserver(() => onWidth(element.clientWidth));
            observer.observe(element);
            onWidth(element.clientWidth);
            return () => observer.disconnect();
        })(),
    'app.web.shell.installDrag' : (element, onStart, onMove, onEnd) => (() => {
            let startX = null;
            let moved = false;
            const down = (e) => {
                if (e.button !== 0) return;
                e.preventDefault();
                e.stopPropagation();
                startX = e.clientX;
                moved = false;
                element.setPointerCapture(e.pointerId);
                onStart();
            };
            const move = (e) => {
                if (startX === null) return;
                if (Math.abs(e.clientX - startX) >= 3) moved = true;
                if (moved) onMove(e.clientX - startX);
            };
            const up = () => { if (startX !== null) { startX = null; onEnd(moved); } };
            element.addEventListener('pointerdown', down);
            element.addEventListener('pointermove', move);
            element.addEventListener('pointerup', up);
            element.addEventListener('pointercancel', up);
            return () => {
                element.removeEventListener('pointerdown', down);
                element.removeEventListener('pointermove', move);
                element.removeEventListener('pointerup', up);
                element.removeEventListener('pointercancel', up);
            };
        })(),
    'app.web.shell.encodeUriComponent' : (value) => encodeURIComponent(value),
    'app.web.shell.addFontFace' : (family, bytes) => {
            new FontFace(family, bytes).load().then((face) => document.fonts.add(face)).catch(() => {});
        },
    'app.web.shell.setFieldContent' : (field, html, empty) => {
            field.innerHTML = html;
            field.classList.toggle('empty', empty);
        },
    'app.web.shell.fitField' : (field) => {
            // Measured against the box, not the field: tall glyphs overflow their lines by a few pixels.
            const box = field.parentElement;
            const style = getComputedStyle(box);
            const room = box.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
            let size = 40;
            field.style.fontSize = size + 'px';
            while (size > 16 && field.scrollHeight > room) {
                size -= 2;
                field.style.fontSize = size + 'px';
            }
        },
    'app.web.shell.fieldText' : (field) => (() => {
            let out = '';
            const walk = (node) => {
                for (const child of node.childNodes) {
                    if (child.nodeType === 3) out += child.data;
                    else if (child.nodeName === 'BR') { if (!child.hasAttribute('data-end')) out += '\n'; }
                    else {
                        if ((child.nodeName === 'DIV' || child.nodeName === 'P') && out.length && !out.endsWith('\n')) out += '\n';
                        walk(child);
                    }
                }
            };
            walk(field);
            return out;
        })(),
    'app.web.shell.fieldSelectionOffsets' : (field) => (() => {
            const selection = document.getSelection();
            if (!selection || selection.rangeCount === 0 || !field.contains(selection.anchorNode)) return null;
            const length = (node, offset) => {
                const range = document.createRange();
                range.setStart(field, 0);
                range.setEnd(node, offset);
                let count = 0;
                const walk = (n) => {
                    for (const child of n.childNodes) {
                        if (child.nodeType === 3) count += child.data.length;
                        else if (child.nodeName === 'BR') { if (!child.hasAttribute('data-end')) count += 1; }
                        else walk(child);
                    }
                };
                walk(range.cloneContents());
                return count;
            };
            const anchor = length(selection.anchorNode, selection.anchorOffset);
            const focus = length(selection.focusNode, selection.focusOffset);
            return anchor + ',' + focus;
        })(),
    'app.web.shell.setFieldSelection' : (field, start, end) => {
            const point = (offset) => {
                let count = 0;
                let found = null;
                const walk = (n) => {
                    for (const child of n.childNodes) {
                        if (found) return;
                        if (child.nodeType === 3) {
                            if (offset <= count + child.data.length) { found = [child, offset - count]; return; }
                            count += child.data.length;
                        } else if (child.nodeName === 'BR') {
                            if (child.hasAttribute('data-end')) continue;
                            if (offset === count) { found = [n, Array.prototype.indexOf.call(n.childNodes, child)]; return; }
                            count += 1;
                        } else walk(child);
                    }
                };
                walk(field);
                return found || [field, field.childNodes.length];
            };
            const [anchorNode, anchorOffset] = point(start);
            const [focusNode, focusOffset] = point(end);
            document.getSelection()?.setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset);
        },
    'app.web.shell.installField' : (field, onEdit, onKey, onPaste, onHistory, onSelection, onFontsLoaded) => (() => {
            let composing = false;
            const input = (e) => { if (!composing && !e.isComposing) onEdit(); };
            const compositionStart = () => { composing = true; };
            const compositionEnd = () => { composing = false; onEdit(); };
            const beforeInput = (e) => {
                if (e.inputType === 'historyUndo' || e.inputType === 'historyRedo') {
                    e.preventDefault();
                    onHistory(e.inputType === 'historyRedo');
                } else if (e.inputType.startsWith('format') || e.inputType === 'insertFromDrop') {
                    e.preventDefault();
                }
            };
            const keyDown = (e) => {
                // The editor's shortcuts must not see the writing's keys.
                e.stopPropagation();
                if (e.isComposing || composing) return;
                if (onKey(e.key, e.metaKey || e.ctrlKey, e.shiftKey)) e.preventDefault();
            };
            const paste = (e) => {
                e.preventDefault();
                onPaste((e.clipboardData && e.clipboardData.getData('text/plain')) || '');
            };
            const drop = (e) => e.preventDefault();
            const selection = () => { if (document.activeElement === field) onSelection(); };
            field.addEventListener('input', input);
            field.addEventListener('compositionstart', compositionStart);
            field.addEventListener('compositionend', compositionEnd);
            field.addEventListener('beforeinput', beforeInput);
            field.addEventListener('keydown', keyDown);
            field.addEventListener('paste', paste);
            field.addEventListener('drop', drop);
            document.addEventListener('selectionchange', selection);
            // Faces arrive after the text is drawn, and they change its size.
            const fontsLoaded = () => onFontsLoaded();
            document.fonts.addEventListener('loadingdone', fontsLoaded);
            return () => {
                document.fonts.removeEventListener('loadingdone', fontsLoaded);
                field.removeEventListener('input', input);
                field.removeEventListener('compositionstart', compositionStart);
                field.removeEventListener('compositionend', compositionEnd);
                field.removeEventListener('beforeinput', beforeInput);
                field.removeEventListener('keydown', keyDown);
                field.removeEventListener('paste', paste);
                field.removeEventListener('drop', drop);
                document.removeEventListener('selectionchange', selection);
            };
        })(),
    'app.web.shell.focusField' : (field) => field.focus({ preventScroll: true })
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    